"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashmixIconSizeRegistry = exports.dashmixIconClassRegistry = void 0;
const composables_1 = require("../../../../../composables");
const Icon_contracts_1 = require("./Icon.contracts");
/**
 * Registry that binds the `IconName` with the applicable set of CSS classes.
 *
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 *
 * @see DashmixIconName
 */
exports.dashmixIconClassRegistry = {
    [Icon_contracts_1.DashmixIconName.AccessibleIconBrand]: 'fab fa-accessible-icon',
    [Icon_contracts_1.DashmixIconName.AccusoftBrand]: 'fab fa-accusoft',
    [Icon_contracts_1.DashmixIconName.AcquisitionsIncorporatedBrand]: 'fab fa-acquisitions-incorporated',
    [Icon_contracts_1.DashmixIconName.AdSolid]: 'fas fa-ad',
    [Icon_contracts_1.DashmixIconName.AddressBookSolid]: 'fas fa-address-book',
    [Icon_contracts_1.DashmixIconName.AddressBook]: 'far fa-address-book',
    [Icon_contracts_1.DashmixIconName.AddressCardSolid]: 'fas fa-address-card',
    [Icon_contracts_1.DashmixIconName.AddressCard]: 'far fa-address-card',
    [Icon_contracts_1.DashmixIconName.AdjustSolid]: 'fas fa-adjust',
    [Icon_contracts_1.DashmixIconName.AdnBrand]: 'fab fa-adn',
    [Icon_contracts_1.DashmixIconName.AdobeBrand]: 'fab fa-adobe',
    [Icon_contracts_1.DashmixIconName.AdversalBrand]: 'fab fa-adversal',
    [Icon_contracts_1.DashmixIconName.AffiliatethemeBrand]: 'fab fa-affiliatetheme',
    [Icon_contracts_1.DashmixIconName.AirFreshenerSolid]: 'fas fa-air-freshener',
    [Icon_contracts_1.DashmixIconName.AirbnbBrand]: 'fab fa-airbnb',
    [Icon_contracts_1.DashmixIconName.AlgoliaBrand]: 'fab fa-algolia',
    [Icon_contracts_1.DashmixIconName.AlignCenterSolid]: 'fas fa-align-center',
    [Icon_contracts_1.DashmixIconName.AlignJustifySolid]: 'fas fa-align-justify',
    [Icon_contracts_1.DashmixIconName.AlignLeftSolid]: 'fas fa-align-left',
    [Icon_contracts_1.DashmixIconName.AlignRightSolid]: 'fas fa-align-right',
    [Icon_contracts_1.DashmixIconName.AlipayBrand]: 'fab fa-alipay',
    [Icon_contracts_1.DashmixIconName.AllergiesSolid]: 'fas fa-allergies',
    [Icon_contracts_1.DashmixIconName.AmazonBrand]: 'fab fa-amazon',
    [Icon_contracts_1.DashmixIconName.AmazonPayBrand]: 'fab fa-amazon-pay',
    [Icon_contracts_1.DashmixIconName.AmbulanceSolid]: 'fas fa-ambulance',
    [Icon_contracts_1.DashmixIconName.AmericanSignLanguageInterpretingSolid]: 'fas fa-american-sign-language-interpreting',
    [Icon_contracts_1.DashmixIconName.AmiliaBrand]: 'fab fa-amilia',
    [Icon_contracts_1.DashmixIconName.AnchorSolid]: 'fas fa-anchor',
    [Icon_contracts_1.DashmixIconName.AndroidBrand]: 'fab fa-android',
    [Icon_contracts_1.DashmixIconName.AngellistBrand]: 'fab fa-angellist',
    [Icon_contracts_1.DashmixIconName.AngleDoubleDownSolid]: 'fas fa-angle-double-down',
    [Icon_contracts_1.DashmixIconName.AngleDoubleLeftSolid]: 'fas fa-angle-double-left',
    [Icon_contracts_1.DashmixIconName.AngleDoubleRightSolid]: 'fas fa-angle-double-right',
    [Icon_contracts_1.DashmixIconName.AngleDoubleUpSolid]: 'fas fa-angle-double-up',
    [Icon_contracts_1.DashmixIconName.AngleDownSolid]: 'fas fa-angle-down',
    [Icon_contracts_1.DashmixIconName.AngleLeftSolid]: 'fas fa-angle-left',
    [Icon_contracts_1.DashmixIconName.AngleRightSolid]: 'fas fa-angle-right',
    [Icon_contracts_1.DashmixIconName.AngleUpSolid]: 'fas fa-angle-up',
    [Icon_contracts_1.DashmixIconName.AngrySolid]: 'fas fa-angry',
    [Icon_contracts_1.DashmixIconName.Angry]: 'far fa-angry',
    [Icon_contracts_1.DashmixIconName.AngrycreativeBrand]: 'fab fa-angrycreative',
    [Icon_contracts_1.DashmixIconName.AngularBrand]: 'fab fa-angular',
    [Icon_contracts_1.DashmixIconName.AnkhSolid]: 'fas fa-ankh',
    [Icon_contracts_1.DashmixIconName.AppStoreBrand]: 'fab fa-app-store',
    [Icon_contracts_1.DashmixIconName.AppStoreIosBrand]: 'fab fa-app-store-ios',
    [Icon_contracts_1.DashmixIconName.ApperBrand]: 'fab fa-apper',
    [Icon_contracts_1.DashmixIconName.AppleAltSolid]: 'fas fa-apple-alt',
    [Icon_contracts_1.DashmixIconName.AppleBrand]: 'fab fa-apple',
    [Icon_contracts_1.DashmixIconName.ApplePayBrand]: 'fab fa-apple-pay',
    [Icon_contracts_1.DashmixIconName.ArchiveSolid]: 'fas fa-archive',
    [Icon_contracts_1.DashmixIconName.ArchwaySolid]: 'fas fa-archway',
    [Icon_contracts_1.DashmixIconName.ArrowAltCircleDownSolid]: 'fas fa-arrow-alt-circle-down',
    [Icon_contracts_1.DashmixIconName.ArrowAltCircleDown]: 'far fa-arrow-alt-circle-down',
    [Icon_contracts_1.DashmixIconName.ArrowAltCircleLeftSolid]: 'fas fa-arrow-alt-circle-left',
    [Icon_contracts_1.DashmixIconName.ArrowAltCircleLeft]: 'far fa-arrow-alt-circle-left',
    [Icon_contracts_1.DashmixIconName.ArrowAltCircleRightSolid]: 'fas fa-arrow-alt-circle-right',
    [Icon_contracts_1.DashmixIconName.ArrowAltCircleRight]: 'far fa-arrow-alt-circle-right',
    [Icon_contracts_1.DashmixIconName.ArrowAltCircleUpSolid]: 'fas fa-arrow-alt-circle-up',
    [Icon_contracts_1.DashmixIconName.ArrowAltCircleUp]: 'far fa-arrow-alt-circle-up',
    [Icon_contracts_1.DashmixIconName.ArrowCircleDownSolid]: 'fas fa-arrow-circle-down',
    [Icon_contracts_1.DashmixIconName.ArrowCircleLeftSolid]: 'fas fa-arrow-circle-left',
    [Icon_contracts_1.DashmixIconName.ArrowCircleRightSolid]: 'fas fa-arrow-circle-right',
    [Icon_contracts_1.DashmixIconName.ArrowCircleUpSolid]: 'fas fa-arrow-circle-up',
    [Icon_contracts_1.DashmixIconName.ArrowDownSolid]: 'fas fa-arrow-down',
    [Icon_contracts_1.DashmixIconName.ArrowLeftSolid]: 'fas fa-arrow-left',
    [Icon_contracts_1.DashmixIconName.ArrowRightSolid]: 'fas fa-arrow-right',
    [Icon_contracts_1.DashmixIconName.ArrowUpSolid]: 'fas fa-arrow-up',
    [Icon_contracts_1.DashmixIconName.ArrowsAltHSolid]: 'fas fa-arrows-alt-h',
    [Icon_contracts_1.DashmixIconName.ArrowsAltSolid]: 'fas fa-arrows-alt',
    [Icon_contracts_1.DashmixIconName.ArrowsAltVSolid]: 'fas fa-arrows-alt-v',
    [Icon_contracts_1.DashmixIconName.ArtstationBrand]: 'fab fa-artstation',
    [Icon_contracts_1.DashmixIconName.AssistiveListeningSystemsSolid]: 'fas fa-assistive-listening-systems',
    [Icon_contracts_1.DashmixIconName.AsteriskSolid]: 'fas fa-asterisk',
    [Icon_contracts_1.DashmixIconName.AsymmetrikBrand]: 'fab fa-asymmetrik',
    [Icon_contracts_1.DashmixIconName.AtSolid]: 'fas fa-at',
    [Icon_contracts_1.DashmixIconName.AtlasSolid]: 'fas fa-atlas',
    [Icon_contracts_1.DashmixIconName.AtlassianBrand]: 'fab fa-atlassian',
    [Icon_contracts_1.DashmixIconName.AtomSolid]: 'fas fa-atom',
    [Icon_contracts_1.DashmixIconName.AudibleBrand]: 'fab fa-audible',
    [Icon_contracts_1.DashmixIconName.AudioDescriptionSolid]: 'fas fa-audio-description',
    [Icon_contracts_1.DashmixIconName.AutoprefixerBrand]: 'fab fa-autoprefixer',
    [Icon_contracts_1.DashmixIconName.AvianexBrand]: 'fab fa-avianex',
    [Icon_contracts_1.DashmixIconName.AviatoBrand]: 'fab fa-aviato',
    [Icon_contracts_1.DashmixIconName.AwardSolid]: 'fas fa-award',
    [Icon_contracts_1.DashmixIconName.AwsBrand]: 'fab fa-aws',
    [Icon_contracts_1.DashmixIconName.BabyCarriageSolid]: 'fas fa-baby-carriage',
    [Icon_contracts_1.DashmixIconName.BabySolid]: 'fas fa-baby',
    [Icon_contracts_1.DashmixIconName.BackspaceSolid]: 'fas fa-backspace',
    [Icon_contracts_1.DashmixIconName.BackwardSolid]: 'fas fa-backward',
    [Icon_contracts_1.DashmixIconName.BaconSolid]: 'fas fa-bacon',
    [Icon_contracts_1.DashmixIconName.BahaiSolid]: 'fas fa-bahai',
    [Icon_contracts_1.DashmixIconName.BalanceScaleLeftSolid]: 'fas fa-balance-scale-left',
    [Icon_contracts_1.DashmixIconName.BalanceScaleRightSolid]: 'fas fa-balance-scale-right',
    [Icon_contracts_1.DashmixIconName.BalanceScaleSolid]: 'fas fa-balance-scale',
    [Icon_contracts_1.DashmixIconName.BanSolid]: 'fas fa-ban',
    [Icon_contracts_1.DashmixIconName.BandAidSolid]: 'fas fa-band-aid',
    [Icon_contracts_1.DashmixIconName.BandcampBrand]: 'fab fa-bandcamp',
    [Icon_contracts_1.DashmixIconName.BarcodeSolid]: 'fas fa-barcode',
    [Icon_contracts_1.DashmixIconName.BarsSolid]: 'fas fa-bars',
    [Icon_contracts_1.DashmixIconName.BaseballBallSolid]: 'fas fa-baseball-ball',
    [Icon_contracts_1.DashmixIconName.BasketballBallSolid]: 'fas fa-basketball-ball',
    [Icon_contracts_1.DashmixIconName.BathSolid]: 'fas fa-bath',
    [Icon_contracts_1.DashmixIconName.BatteryEmptySolid]: 'fas fa-battery-empty',
    [Icon_contracts_1.DashmixIconName.BatteryFullSolid]: 'fas fa-battery-full',
    [Icon_contracts_1.DashmixIconName.BatteryHalfSolid]: 'fas fa-battery-half',
    [Icon_contracts_1.DashmixIconName.BatteryQuarterSolid]: 'fas fa-battery-quarter',
    [Icon_contracts_1.DashmixIconName.BatteryThreeQuartersSolid]: 'fas fa-battery-three-quarters',
    [Icon_contracts_1.DashmixIconName.BattleNetBrand]: 'fab fa-battle-net',
    [Icon_contracts_1.DashmixIconName.BedSolid]: 'fas fa-bed',
    [Icon_contracts_1.DashmixIconName.BeerSolid]: 'fas fa-beer',
    [Icon_contracts_1.DashmixIconName.BehanceBrand]: 'fab fa-behance',
    [Icon_contracts_1.DashmixIconName.BehanceSquareBrand]: 'fab fa-behance-square',
    [Icon_contracts_1.DashmixIconName.BellSlashSolid]: 'fas fa-bell-slash',
    [Icon_contracts_1.DashmixIconName.BellSlash]: 'far fa-bell-slash',
    [Icon_contracts_1.DashmixIconName.BellSolid]: 'fas fa-bell',
    [Icon_contracts_1.DashmixIconName.Bell]: 'far fa-bell',
    [Icon_contracts_1.DashmixIconName.BezierCurveSolid]: 'fas fa-bezier-curve',
    [Icon_contracts_1.DashmixIconName.BibleSolid]: 'fas fa-bible',
    [Icon_contracts_1.DashmixIconName.BicycleSolid]: 'fas fa-bicycle',
    [Icon_contracts_1.DashmixIconName.BikingSolid]: 'fas fa-biking',
    [Icon_contracts_1.DashmixIconName.BimobjectBrand]: 'fab fa-bimobject',
    [Icon_contracts_1.DashmixIconName.BinocularsSolid]: 'fas fa-binoculars',
    [Icon_contracts_1.DashmixIconName.BiohazardSolid]: 'fas fa-biohazard',
    [Icon_contracts_1.DashmixIconName.BirthdayCakeSolid]: 'fas fa-birthday-cake',
    [Icon_contracts_1.DashmixIconName.BitbucketBrand]: 'fab fa-bitbucket',
    [Icon_contracts_1.DashmixIconName.BitcoinBrand]: 'fab fa-bitcoin',
    [Icon_contracts_1.DashmixIconName.BityBrand]: 'fab fa-bity',
    [Icon_contracts_1.DashmixIconName.BlackTieBrand]: 'fab fa-black-tie',
    [Icon_contracts_1.DashmixIconName.BlackberryBrand]: 'fab fa-blackberry',
    [Icon_contracts_1.DashmixIconName.BlenderPhoneSolid]: 'fas fa-blender-phone',
    [Icon_contracts_1.DashmixIconName.BlenderSolid]: 'fas fa-blender',
    [Icon_contracts_1.DashmixIconName.BlindSolid]: 'fas fa-blind',
    [Icon_contracts_1.DashmixIconName.BlogSolid]: 'fas fa-blog',
    [Icon_contracts_1.DashmixIconName.BloggerBBrand]: 'fab fa-blogger-b',
    [Icon_contracts_1.DashmixIconName.BloggerBrand]: 'fab fa-blogger',
    [Icon_contracts_1.DashmixIconName.BluetoothBBrand]: 'fab fa-bluetooth-b',
    [Icon_contracts_1.DashmixIconName.BluetoothBrand]: 'fab fa-bluetooth',
    [Icon_contracts_1.DashmixIconName.BoldSolid]: 'fas fa-bold',
    [Icon_contracts_1.DashmixIconName.BoltSolid]: 'fas fa-bolt',
    [Icon_contracts_1.DashmixIconName.BombSolid]: 'fas fa-bomb',
    [Icon_contracts_1.DashmixIconName.BoneSolid]: 'fas fa-bone',
    [Icon_contracts_1.DashmixIconName.BongSolid]: 'fas fa-bong',
    [Icon_contracts_1.DashmixIconName.BookDeadSolid]: 'fas fa-book-dead',
    [Icon_contracts_1.DashmixIconName.BookMedicalSolid]: 'fas fa-book-medical',
    [Icon_contracts_1.DashmixIconName.BookOpenSolid]: 'fas fa-book-open',
    [Icon_contracts_1.DashmixIconName.BookReaderSolid]: 'fas fa-book-reader',
    [Icon_contracts_1.DashmixIconName.BookSolid]: 'fas fa-book',
    [Icon_contracts_1.DashmixIconName.BookmarkSolid]: 'fas fa-bookmark',
    [Icon_contracts_1.DashmixIconName.Bookmark]: 'far fa-bookmark',
    [Icon_contracts_1.DashmixIconName.BootstrapBrand]: 'fab fa-bootstrap',
    [Icon_contracts_1.DashmixIconName.BorderAllSolid]: 'fas fa-border-all',
    [Icon_contracts_1.DashmixIconName.BorderNoneSolid]: 'fas fa-border-none',
    [Icon_contracts_1.DashmixIconName.BorderStyleSolid]: 'fas fa-border-style',
    [Icon_contracts_1.DashmixIconName.BowlingBallSolid]: 'fas fa-bowling-ball',
    [Icon_contracts_1.DashmixIconName.BoxOpenSolid]: 'fas fa-box-open',
    [Icon_contracts_1.DashmixIconName.BoxSolid]: 'fas fa-box',
    [Icon_contracts_1.DashmixIconName.BoxesSolid]: 'fas fa-boxes',
    [Icon_contracts_1.DashmixIconName.BrailleSolid]: 'fas fa-braille',
    [Icon_contracts_1.DashmixIconName.BrainSolid]: 'fas fa-brain',
    [Icon_contracts_1.DashmixIconName.BreadSliceSolid]: 'fas fa-bread-slice',
    [Icon_contracts_1.DashmixIconName.BriefcaseMedicalSolid]: 'fas fa-briefcase-medical',
    [Icon_contracts_1.DashmixIconName.BriefcaseSolid]: 'fas fa-briefcase',
    [Icon_contracts_1.DashmixIconName.BroadcastTowerSolid]: 'fas fa-broadcast-tower',
    [Icon_contracts_1.DashmixIconName.BroomSolid]: 'fas fa-broom',
    [Icon_contracts_1.DashmixIconName.BrushSolid]: 'fas fa-brush',
    [Icon_contracts_1.DashmixIconName.BtcBrand]: 'fab fa-btc',
    [Icon_contracts_1.DashmixIconName.BufferBrand]: 'fab fa-buffer',
    [Icon_contracts_1.DashmixIconName.BugSolid]: 'fas fa-bug',
    [Icon_contracts_1.DashmixIconName.BuildingSolid]: 'fas fa-building',
    [Icon_contracts_1.DashmixIconName.Building]: 'far fa-building',
    [Icon_contracts_1.DashmixIconName.BullhornSolid]: 'fas fa-bullhorn',
    [Icon_contracts_1.DashmixIconName.BullseyeSolid]: 'fas fa-bullseye',
    [Icon_contracts_1.DashmixIconName.BurnSolid]: 'fas fa-burn',
    [Icon_contracts_1.DashmixIconName.BuromobelexperteBrand]: 'fab fa-buromobelexperte',
    [Icon_contracts_1.DashmixIconName.BusAltSolid]: 'fas fa-bus-alt',
    [Icon_contracts_1.DashmixIconName.BusSolid]: 'fas fa-bus',
    [Icon_contracts_1.DashmixIconName.BusinessTimeSolid]: 'fas fa-business-time',
    [Icon_contracts_1.DashmixIconName.BuyNLargeBrand]: 'fab fa-buy-n-large',
    [Icon_contracts_1.DashmixIconName.BuyselladsBrand]: 'fab fa-buysellads',
    [Icon_contracts_1.DashmixIconName.CalculatorSolid]: 'fas fa-calculator',
    [Icon_contracts_1.DashmixIconName.CalendarAltSolid]: 'fas fa-calendar-alt',
    [Icon_contracts_1.DashmixIconName.CalendarAlt]: 'far fa-calendar-alt',
    [Icon_contracts_1.DashmixIconName.CalendarCheckSolid]: 'fas fa-calendar-check',
    [Icon_contracts_1.DashmixIconName.CalendarCheck]: 'far fa-calendar-check',
    [Icon_contracts_1.DashmixIconName.CalendarDaySolid]: 'fas fa-calendar-day',
    [Icon_contracts_1.DashmixIconName.CalendarMinusSolid]: 'fas fa-calendar-minus',
    [Icon_contracts_1.DashmixIconName.CalendarMinus]: 'far fa-calendar-minus',
    [Icon_contracts_1.DashmixIconName.CalendarPlusSolid]: 'fas fa-calendar-plus',
    [Icon_contracts_1.DashmixIconName.CalendarPlus]: 'far fa-calendar-plus',
    [Icon_contracts_1.DashmixIconName.CalendarSolid]: 'fas fa-calendar',
    [Icon_contracts_1.DashmixIconName.CalendarTimesSolid]: 'fas fa-calendar-times',
    [Icon_contracts_1.DashmixIconName.CalendarTimes]: 'far fa-calendar-times',
    [Icon_contracts_1.DashmixIconName.CalendarWeekSolid]: 'fas fa-calendar-week',
    [Icon_contracts_1.DashmixIconName.Calendar]: 'far fa-calendar',
    [Icon_contracts_1.DashmixIconName.CameraRetroSolid]: 'fas fa-camera-retro',
    [Icon_contracts_1.DashmixIconName.CameraSolid]: 'fas fa-camera',
    [Icon_contracts_1.DashmixIconName.CampgroundSolid]: 'fas fa-campground',
    [Icon_contracts_1.DashmixIconName.CanadianMapleLeafBrand]: 'fab fa-canadian-maple-leaf',
    [Icon_contracts_1.DashmixIconName.CandyCaneSolid]: 'fas fa-candy-cane',
    [Icon_contracts_1.DashmixIconName.CannabisSolid]: 'fas fa-cannabis',
    [Icon_contracts_1.DashmixIconName.CapsulesSolid]: 'fas fa-capsules',
    [Icon_contracts_1.DashmixIconName.CarAltSolid]: 'fas fa-car-alt',
    [Icon_contracts_1.DashmixIconName.CarBatterySolid]: 'fas fa-car-battery',
    [Icon_contracts_1.DashmixIconName.CarCrashSolid]: 'fas fa-car-crash',
    [Icon_contracts_1.DashmixIconName.CarSideSolid]: 'fas fa-car-side',
    [Icon_contracts_1.DashmixIconName.CarSolid]: 'fas fa-car',
    [Icon_contracts_1.DashmixIconName.CaravanSolid]: 'fas fa-caravan',
    [Icon_contracts_1.DashmixIconName.CaretDownSolid]: 'fas fa-caret-down',
    [Icon_contracts_1.DashmixIconName.CaretLeftSolid]: 'fas fa-caret-left',
    [Icon_contracts_1.DashmixIconName.CaretRightSolid]: 'fas fa-caret-right',
    [Icon_contracts_1.DashmixIconName.CaretSquareDownSolid]: 'fas fa-caret-square-down',
    [Icon_contracts_1.DashmixIconName.CaretSquareDown]: 'far fa-caret-square-down',
    [Icon_contracts_1.DashmixIconName.CaretSquareLeftSolid]: 'fas fa-caret-square-left',
    [Icon_contracts_1.DashmixIconName.CaretSquareLeft]: 'far fa-caret-square-left',
    [Icon_contracts_1.DashmixIconName.CaretSquareRightSolid]: 'fas fa-caret-square-right',
    [Icon_contracts_1.DashmixIconName.CaretSquareRight]: 'far fa-caret-square-right',
    [Icon_contracts_1.DashmixIconName.CaretSquareUpSolid]: 'fas fa-caret-square-up',
    [Icon_contracts_1.DashmixIconName.CaretSquareUp]: 'far fa-caret-square-up',
    [Icon_contracts_1.DashmixIconName.CaretUpSolid]: 'fas fa-caret-up',
    [Icon_contracts_1.DashmixIconName.CarrotSolid]: 'fas fa-carrot',
    [Icon_contracts_1.DashmixIconName.CartArrowDownSolid]: 'fas fa-cart-arrow-down',
    [Icon_contracts_1.DashmixIconName.CartPlusSolid]: 'fas fa-cart-plus',
    [Icon_contracts_1.DashmixIconName.CashRegisterSolid]: 'fas fa-cash-register',
    [Icon_contracts_1.DashmixIconName.CatSolid]: 'fas fa-cat',
    [Icon_contracts_1.DashmixIconName.CcAmazonPayBrand]: 'fab fa-cc-amazon-pay',
    [Icon_contracts_1.DashmixIconName.CcAmexBrand]: 'fab fa-cc-amex',
    [Icon_contracts_1.DashmixIconName.CcApplePayBrand]: 'fab fa-cc-apple-pay',
    [Icon_contracts_1.DashmixIconName.CcDinersClubBrand]: 'fab fa-cc-diners-club',
    [Icon_contracts_1.DashmixIconName.CcDiscoverBrand]: 'fab fa-cc-discover',
    [Icon_contracts_1.DashmixIconName.CcJcbBrand]: 'fab fa-cc-jcb',
    [Icon_contracts_1.DashmixIconName.CcMastercardBrand]: 'fab fa-cc-mastercard',
    [Icon_contracts_1.DashmixIconName.CcPaypalBrand]: 'fab fa-cc-paypal',
    [Icon_contracts_1.DashmixIconName.CcStripeBrand]: 'fab fa-cc-stripe',
    [Icon_contracts_1.DashmixIconName.CcVisaBrand]: 'fab fa-cc-visa',
    [Icon_contracts_1.DashmixIconName.CentercodeBrand]: 'fab fa-centercode',
    [Icon_contracts_1.DashmixIconName.CentosBrand]: 'fab fa-centos',
    [Icon_contracts_1.DashmixIconName.CertificateSolid]: 'fas fa-certificate',
    [Icon_contracts_1.DashmixIconName.ChairSolid]: 'fas fa-chair',
    [Icon_contracts_1.DashmixIconName.ChalkboardSolid]: 'fas fa-chalkboard',
    [Icon_contracts_1.DashmixIconName.ChalkboardTeacherSolid]: 'fas fa-chalkboard-teacher',
    [Icon_contracts_1.DashmixIconName.ChargingStationSolid]: 'fas fa-charging-station',
    [Icon_contracts_1.DashmixIconName.ChartAreaSolid]: 'fas fa-chart-area',
    [Icon_contracts_1.DashmixIconName.ChartBarSolid]: 'fas fa-chart-bar',
    [Icon_contracts_1.DashmixIconName.ChartBar]: 'far fa-chart-bar',
    [Icon_contracts_1.DashmixIconName.ChartLineSolid]: 'fas fa-chart-line',
    [Icon_contracts_1.DashmixIconName.ChartPieSolid]: 'fas fa-chart-pie',
    [Icon_contracts_1.DashmixIconName.CheckCircleSolid]: 'fas fa-check-circle',
    [Icon_contracts_1.DashmixIconName.CheckCircle]: 'far fa-check-circle',
    [Icon_contracts_1.DashmixIconName.CheckDoubleSolid]: 'fas fa-check-double',
    [Icon_contracts_1.DashmixIconName.CheckSolid]: 'fas fa-check',
    [Icon_contracts_1.DashmixIconName.CheckSquareSolid]: 'fas fa-check-square',
    [Icon_contracts_1.DashmixIconName.CheckSquare]: 'far fa-check-square',
    [Icon_contracts_1.DashmixIconName.CheeseSolid]: 'fas fa-cheese',
    [Icon_contracts_1.DashmixIconName.ChessBishopSolid]: 'fas fa-chess-bishop',
    [Icon_contracts_1.DashmixIconName.ChessBoardSolid]: 'fas fa-chess-board',
    [Icon_contracts_1.DashmixIconName.ChessKingSolid]: 'fas fa-chess-king',
    [Icon_contracts_1.DashmixIconName.ChessKnightSolid]: 'fas fa-chess-knight',
    [Icon_contracts_1.DashmixIconName.ChessPawnSolid]: 'fas fa-chess-pawn',
    [Icon_contracts_1.DashmixIconName.ChessQueenSolid]: 'fas fa-chess-queen',
    [Icon_contracts_1.DashmixIconName.ChessRookSolid]: 'fas fa-chess-rook',
    [Icon_contracts_1.DashmixIconName.ChessSolid]: 'fas fa-chess',
    [Icon_contracts_1.DashmixIconName.ChevronCircleDownSolid]: 'fas fa-chevron-circle-down',
    [Icon_contracts_1.DashmixIconName.ChevronCircleLeftSolid]: 'fas fa-chevron-circle-left',
    [Icon_contracts_1.DashmixIconName.ChevronCircleRightSolid]: 'fas fa-chevron-circle-right',
    [Icon_contracts_1.DashmixIconName.ChevronCircleUpSolid]: 'fas fa-chevron-circle-up',
    [Icon_contracts_1.DashmixIconName.ChevronDownSolid]: 'fas fa-chevron-down',
    [Icon_contracts_1.DashmixIconName.ChevronLeftSolid]: 'fas fa-chevron-left',
    [Icon_contracts_1.DashmixIconName.ChevronRightSolid]: 'fas fa-chevron-right',
    [Icon_contracts_1.DashmixIconName.ChevronUpSolid]: 'fas fa-chevron-up',
    [Icon_contracts_1.DashmixIconName.ChildSolid]: 'fas fa-child',
    [Icon_contracts_1.DashmixIconName.ChromeBrand]: 'fab fa-chrome',
    [Icon_contracts_1.DashmixIconName.ChromecastBrand]: 'fab fa-chromecast',
    [Icon_contracts_1.DashmixIconName.ChurchSolid]: 'fas fa-church',
    [Icon_contracts_1.DashmixIconName.CircleNotchSolid]: 'fas fa-circle-notch',
    [Icon_contracts_1.DashmixIconName.CircleSolid]: 'fas fa-circle',
    [Icon_contracts_1.DashmixIconName.Circle]: 'far fa-circle',
    [Icon_contracts_1.DashmixIconName.CitySolid]: 'fas fa-city',
    [Icon_contracts_1.DashmixIconName.ClinicMedicalSolid]: 'fas fa-clinic-medical',
    [Icon_contracts_1.DashmixIconName.ClipboardCheckSolid]: 'fas fa-clipboard-check',
    [Icon_contracts_1.DashmixIconName.ClipboardListSolid]: 'fas fa-clipboard-list',
    [Icon_contracts_1.DashmixIconName.ClipboardSolid]: 'fas fa-clipboard',
    [Icon_contracts_1.DashmixIconName.Clipboard]: 'far fa-clipboard',
    [Icon_contracts_1.DashmixIconName.ClockSolid]: 'fas fa-clock',
    [Icon_contracts_1.DashmixIconName.Clock]: 'far fa-clock',
    [Icon_contracts_1.DashmixIconName.CloneSolid]: 'fas fa-clone',
    [Icon_contracts_1.DashmixIconName.Clone]: 'far fa-clone',
    [Icon_contracts_1.DashmixIconName.ClosedCaptioningSolid]: 'fas fa-closed-captioning',
    [Icon_contracts_1.DashmixIconName.ClosedCaptioning]: 'far fa-closed-captioning',
    [Icon_contracts_1.DashmixIconName.CloudDownloadAltSolid]: 'fas fa-cloud-download-alt',
    [Icon_contracts_1.DashmixIconName.CloudMeatballSolid]: 'fas fa-cloud-meatball',
    [Icon_contracts_1.DashmixIconName.CloudMoonRainSolid]: 'fas fa-cloud-moon-rain',
    [Icon_contracts_1.DashmixIconName.CloudMoonSolid]: 'fas fa-cloud-moon',
    [Icon_contracts_1.DashmixIconName.CloudRainSolid]: 'fas fa-cloud-rain',
    [Icon_contracts_1.DashmixIconName.CloudShowersHeavySolid]: 'fas fa-cloud-showers-heavy',
    [Icon_contracts_1.DashmixIconName.CloudSolid]: 'fas fa-cloud',
    [Icon_contracts_1.DashmixIconName.CloudSunRainSolid]: 'fas fa-cloud-sun-rain',
    [Icon_contracts_1.DashmixIconName.CloudSunSolid]: 'fas fa-cloud-sun',
    [Icon_contracts_1.DashmixIconName.CloudUploadAltSolid]: 'fas fa-cloud-upload-alt',
    [Icon_contracts_1.DashmixIconName.CloudscaleBrand]: 'fab fa-cloudscale',
    [Icon_contracts_1.DashmixIconName.CloudsmithBrand]: 'fab fa-cloudsmith',
    [Icon_contracts_1.DashmixIconName.CloudversifyBrand]: 'fab fa-cloudversify',
    [Icon_contracts_1.DashmixIconName.CocktailSolid]: 'fas fa-cocktail',
    [Icon_contracts_1.DashmixIconName.CodeBranchSolid]: 'fas fa-code-branch',
    [Icon_contracts_1.DashmixIconName.CodeSolid]: 'fas fa-code',
    [Icon_contracts_1.DashmixIconName.CodepenBrand]: 'fab fa-codepen',
    [Icon_contracts_1.DashmixIconName.CodiepieBrand]: 'fab fa-codiepie',
    [Icon_contracts_1.DashmixIconName.CoffeeSolid]: 'fas fa-coffee',
    [Icon_contracts_1.DashmixIconName.CogSolid]: 'fas fa-cog',
    [Icon_contracts_1.DashmixIconName.CogsSolid]: 'fas fa-cogs',
    [Icon_contracts_1.DashmixIconName.CoinsSolid]: 'fas fa-coins',
    [Icon_contracts_1.DashmixIconName.ColumnsSolid]: 'fas fa-columns',
    [Icon_contracts_1.DashmixIconName.CommentAltSolid]: 'fas fa-comment-alt',
    [Icon_contracts_1.DashmixIconName.CommentAlt]: 'far fa-comment-alt',
    [Icon_contracts_1.DashmixIconName.CommentDollarSolid]: 'fas fa-comment-dollar',
    [Icon_contracts_1.DashmixIconName.CommentDotsSolid]: 'fas fa-comment-dots',
    [Icon_contracts_1.DashmixIconName.CommentDots]: 'far fa-comment-dots',
    [Icon_contracts_1.DashmixIconName.CommentMedicalSolid]: 'fas fa-comment-medical',
    [Icon_contracts_1.DashmixIconName.CommentSlashSolid]: 'fas fa-comment-slash',
    [Icon_contracts_1.DashmixIconName.CommentSolid]: 'fas fa-comment',
    [Icon_contracts_1.DashmixIconName.Comment]: 'far fa-comment',
    [Icon_contracts_1.DashmixIconName.CommentsDollarSolid]: 'fas fa-comments-dollar',
    [Icon_contracts_1.DashmixIconName.CommentsSolid]: 'fas fa-comments',
    [Icon_contracts_1.DashmixIconName.Comments]: 'far fa-comments',
    [Icon_contracts_1.DashmixIconName.CompactDiscSolid]: 'fas fa-compact-disc',
    [Icon_contracts_1.DashmixIconName.CompassSolid]: 'fas fa-compass',
    [Icon_contracts_1.DashmixIconName.Compass]: 'far fa-compass',
    [Icon_contracts_1.DashmixIconName.CompressAltSolid]: 'fas fa-compress-alt',
    [Icon_contracts_1.DashmixIconName.CompressArrowsAltSolid]: 'fas fa-compress-arrows-alt',
    [Icon_contracts_1.DashmixIconName.CompressSolid]: 'fas fa-compress',
    [Icon_contracts_1.DashmixIconName.ConciergeBellSolid]: 'fas fa-concierge-bell',
    [Icon_contracts_1.DashmixIconName.ConfluenceBrand]: 'fab fa-confluence',
    [Icon_contracts_1.DashmixIconName.ConnectdevelopBrand]: 'fab fa-connectdevelop',
    [Icon_contracts_1.DashmixIconName.ContaoBrand]: 'fab fa-contao',
    [Icon_contracts_1.DashmixIconName.CookieBiteSolid]: 'fas fa-cookie-bite',
    [Icon_contracts_1.DashmixIconName.CookieSolid]: 'fas fa-cookie',
    [Icon_contracts_1.DashmixIconName.CopySolid]: 'fas fa-copy',
    [Icon_contracts_1.DashmixIconName.Copy]: 'far fa-copy',
    [Icon_contracts_1.DashmixIconName.CopyrightSolid]: 'fas fa-copyright',
    [Icon_contracts_1.DashmixIconName.Copyright]: 'far fa-copyright',
    [Icon_contracts_1.DashmixIconName.CottonBureauBrand]: 'fab fa-cotton-bureau',
    [Icon_contracts_1.DashmixIconName.CouchSolid]: 'fas fa-couch',
    [Icon_contracts_1.DashmixIconName.CpanelBrand]: 'fab fa-cpanel',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsBrand]: 'fab fa-creative-commons',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsByBrand]: 'fab fa-creative-commons-by',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsNcBrand]: 'fab fa-creative-commons-nc',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsNcEuBrand]: 'fab fa-creative-commons-nc-eu',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsNcJpBrand]: 'fab fa-creative-commons-nc-jp',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsNdBrand]: 'fab fa-creative-commons-nd',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsPdAltBrand]: 'fab fa-creative-commons-pd-alt',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsPdBrand]: 'fab fa-creative-commons-pd',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsRemixBrand]: 'fab fa-creative-commons-remix',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsSaBrand]: 'fab fa-creative-commons-sa',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsSamplingBrand]: 'fab fa-creative-commons-sampling',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsSamplingPlusBrand]: 'fab fa-creative-commons-sampling-plus',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsShareBrand]: 'fab fa-creative-commons-share',
    [Icon_contracts_1.DashmixIconName.CreativeCommonsZeroBrand]: 'fab fa-creative-commons-zero',
    [Icon_contracts_1.DashmixIconName.CreditCardSolid]: 'fas fa-credit-card',
    [Icon_contracts_1.DashmixIconName.CreditCard]: 'far fa-credit-card',
    [Icon_contracts_1.DashmixIconName.CriticalRoleBrand]: 'fab fa-critical-role',
    [Icon_contracts_1.DashmixIconName.CropAltSolid]: 'fas fa-crop-alt',
    [Icon_contracts_1.DashmixIconName.CropSolid]: 'fas fa-crop',
    [Icon_contracts_1.DashmixIconName.CrossSolid]: 'fas fa-cross',
    [Icon_contracts_1.DashmixIconName.CrosshairsSolid]: 'fas fa-crosshairs',
    [Icon_contracts_1.DashmixIconName.CrowSolid]: 'fas fa-crow',
    [Icon_contracts_1.DashmixIconName.CrownSolid]: 'fas fa-crown',
    [Icon_contracts_1.DashmixIconName.CrutchSolid]: 'fas fa-crutch',
    [Icon_contracts_1.DashmixIconName.Css3AltBrand]: 'fab fa-css3-alt',
    [Icon_contracts_1.DashmixIconName.Css3Brand]: 'fab fa-css3',
    [Icon_contracts_1.DashmixIconName.CubeSolid]: 'fas fa-cube',
    [Icon_contracts_1.DashmixIconName.CubesSolid]: 'fas fa-cubes',
    [Icon_contracts_1.DashmixIconName.CutSolid]: 'fas fa-cut',
    [Icon_contracts_1.DashmixIconName.CuttlefishBrand]: 'fab fa-cuttlefish',
    [Icon_contracts_1.DashmixIconName.DAndDBeyondBrand]: 'fab fa-d-and-d-beyond',
    [Icon_contracts_1.DashmixIconName.DAndDBrand]: 'fab fa-d-and-d',
    [Icon_contracts_1.DashmixIconName.DailymotionBrand]: 'fab fa-dailymotion',
    [Icon_contracts_1.DashmixIconName.DashcubeBrand]: 'fab fa-dashcube',
    [Icon_contracts_1.DashmixIconName.DatabaseSolid]: 'fas fa-database',
    [Icon_contracts_1.DashmixIconName.DeafSolid]: 'fas fa-deaf',
    [Icon_contracts_1.DashmixIconName.DeliciousBrand]: 'fab fa-delicious',
    [Icon_contracts_1.DashmixIconName.DemocratSolid]: 'fas fa-democrat',
    [Icon_contracts_1.DashmixIconName.DeploydogBrand]: 'fab fa-deploydog',
    [Icon_contracts_1.DashmixIconName.DeskproBrand]: 'fab fa-deskpro',
    [Icon_contracts_1.DashmixIconName.DesktopSolid]: 'fas fa-desktop',
    [Icon_contracts_1.DashmixIconName.DevBrand]: 'fab fa-dev',
    [Icon_contracts_1.DashmixIconName.DeviantartBrand]: 'fab fa-deviantart',
    [Icon_contracts_1.DashmixIconName.DharmachakraSolid]: 'fas fa-dharmachakra',
    [Icon_contracts_1.DashmixIconName.DhlBrand]: 'fab fa-dhl',
    [Icon_contracts_1.DashmixIconName.DiagnosesSolid]: 'fas fa-diagnoses',
    [Icon_contracts_1.DashmixIconName.DiasporaBrand]: 'fab fa-diaspora',
    [Icon_contracts_1.DashmixIconName.DiceD20Solid]: 'fas fa-dice-d20',
    [Icon_contracts_1.DashmixIconName.DiceD6Solid]: 'fas fa-dice-d6',
    [Icon_contracts_1.DashmixIconName.DiceFiveSolid]: 'fas fa-dice-five',
    [Icon_contracts_1.DashmixIconName.DiceFourSolid]: 'fas fa-dice-four',
    [Icon_contracts_1.DashmixIconName.DiceOneSolid]: 'fas fa-dice-one',
    [Icon_contracts_1.DashmixIconName.DiceSixSolid]: 'fas fa-dice-six',
    [Icon_contracts_1.DashmixIconName.DiceSolid]: 'fas fa-dice',
    [Icon_contracts_1.DashmixIconName.DiceThreeSolid]: 'fas fa-dice-three',
    [Icon_contracts_1.DashmixIconName.DiceTwoSolid]: 'fas fa-dice-two',
    [Icon_contracts_1.DashmixIconName.DiggBrand]: 'fab fa-digg',
    [Icon_contracts_1.DashmixIconName.DigitalOceanBrand]: 'fab fa-digital-ocean',
    [Icon_contracts_1.DashmixIconName.DigitalTachographSolid]: 'fas fa-digital-tachograph',
    [Icon_contracts_1.DashmixIconName.DirectionsSolid]: 'fas fa-directions',
    [Icon_contracts_1.DashmixIconName.DiscordBrand]: 'fab fa-discord',
    [Icon_contracts_1.DashmixIconName.DiscourseBrand]: 'fab fa-discourse',
    [Icon_contracts_1.DashmixIconName.DivideSolid]: 'fas fa-divide',
    [Icon_contracts_1.DashmixIconName.DizzySolid]: 'fas fa-dizzy',
    [Icon_contracts_1.DashmixIconName.Dizzy]: 'far fa-dizzy',
    [Icon_contracts_1.DashmixIconName.DnaSolid]: 'fas fa-dna',
    [Icon_contracts_1.DashmixIconName.DochubBrand]: 'fab fa-dochub',
    [Icon_contracts_1.DashmixIconName.DockerBrand]: 'fab fa-docker',
    [Icon_contracts_1.DashmixIconName.DogSolid]: 'fas fa-dog',
    [Icon_contracts_1.DashmixIconName.DollarSignSolid]: 'fas fa-dollar-sign',
    [Icon_contracts_1.DashmixIconName.DollyFlatbedSolid]: 'fas fa-dolly-flatbed',
    [Icon_contracts_1.DashmixIconName.DollySolid]: 'fas fa-dolly',
    [Icon_contracts_1.DashmixIconName.DonateSolid]: 'fas fa-donate',
    [Icon_contracts_1.DashmixIconName.DoorClosedSolid]: 'fas fa-door-closed',
    [Icon_contracts_1.DashmixIconName.DoorOpenSolid]: 'fas fa-door-open',
    [Icon_contracts_1.DashmixIconName.DotCircleSolid]: 'fas fa-dot-circle',
    [Icon_contracts_1.DashmixIconName.DotCircle]: 'far fa-dot-circle',
    [Icon_contracts_1.DashmixIconName.DoveSolid]: 'fas fa-dove',
    [Icon_contracts_1.DashmixIconName.DownloadSolid]: 'fas fa-download',
    [Icon_contracts_1.DashmixIconName.Draft2digitalBrand]: 'fab fa-draft2digital',
    [Icon_contracts_1.DashmixIconName.DraftingCompassSolid]: 'fas fa-drafting-compass',
    [Icon_contracts_1.DashmixIconName.DragonSolid]: 'fas fa-dragon',
    [Icon_contracts_1.DashmixIconName.DrawPolygonSolid]: 'fas fa-draw-polygon',
    [Icon_contracts_1.DashmixIconName.DribbbleBrand]: 'fab fa-dribbble',
    [Icon_contracts_1.DashmixIconName.DribbbleSquareBrand]: 'fab fa-dribbble-square',
    [Icon_contracts_1.DashmixIconName.DropboxBrand]: 'fab fa-dropbox',
    [Icon_contracts_1.DashmixIconName.DrumSolid]: 'fas fa-drum',
    [Icon_contracts_1.DashmixIconName.DrumSteelpanSolid]: 'fas fa-drum-steelpan',
    [Icon_contracts_1.DashmixIconName.DrumstickBiteSolid]: 'fas fa-drumstick-bite',
    [Icon_contracts_1.DashmixIconName.DrupalBrand]: 'fab fa-drupal',
    [Icon_contracts_1.DashmixIconName.DumbbellSolid]: 'fas fa-dumbbell',
    [Icon_contracts_1.DashmixIconName.DumpsterFireSolid]: 'fas fa-dumpster-fire',
    [Icon_contracts_1.DashmixIconName.DumpsterSolid]: 'fas fa-dumpster',
    [Icon_contracts_1.DashmixIconName.DungeonSolid]: 'fas fa-dungeon',
    [Icon_contracts_1.DashmixIconName.DyalogBrand]: 'fab fa-dyalog',
    [Icon_contracts_1.DashmixIconName.EarlybirdsBrand]: 'fab fa-earlybirds',
    [Icon_contracts_1.DashmixIconName.EbayBrand]: 'fab fa-ebay',
    [Icon_contracts_1.DashmixIconName.EdgeBrand]: 'fab fa-edge',
    [Icon_contracts_1.DashmixIconName.EditSolid]: 'fas fa-edit',
    [Icon_contracts_1.DashmixIconName.Edit]: 'far fa-edit',
    [Icon_contracts_1.DashmixIconName.EggSolid]: 'fas fa-egg',
    [Icon_contracts_1.DashmixIconName.EjectSolid]: 'fas fa-eject',
    [Icon_contracts_1.DashmixIconName.ElementorBrand]: 'fab fa-elementor',
    [Icon_contracts_1.DashmixIconName.EllipsisHSolid]: 'fas fa-ellipsis-h',
    [Icon_contracts_1.DashmixIconName.EllipsisVSolid]: 'fas fa-ellipsis-v',
    [Icon_contracts_1.DashmixIconName.ElloBrand]: 'fab fa-ello',
    [Icon_contracts_1.DashmixIconName.EmberBrand]: 'fab fa-ember',
    [Icon_contracts_1.DashmixIconName.EmpireBrand]: 'fab fa-empire',
    [Icon_contracts_1.DashmixIconName.EnvelopeOpenSolid]: 'fas fa-envelope-open',
    [Icon_contracts_1.DashmixIconName.EnvelopeOpenTextSolid]: 'fas fa-envelope-open-text',
    [Icon_contracts_1.DashmixIconName.EnvelopeOpen]: 'far fa-envelope-open',
    [Icon_contracts_1.DashmixIconName.EnvelopeSolid]: 'fas fa-envelope',
    [Icon_contracts_1.DashmixIconName.EnvelopeSquareSolid]: 'fas fa-envelope-square',
    [Icon_contracts_1.DashmixIconName.Envelope]: 'far fa-envelope',
    [Icon_contracts_1.DashmixIconName.EnviraBrand]: 'fab fa-envira',
    [Icon_contracts_1.DashmixIconName.EqualsSolid]: 'fas fa-equals',
    [Icon_contracts_1.DashmixIconName.EraserSolid]: 'fas fa-eraser',
    [Icon_contracts_1.DashmixIconName.ErlangBrand]: 'fab fa-erlang',
    [Icon_contracts_1.DashmixIconName.EthereumBrand]: 'fab fa-ethereum',
    [Icon_contracts_1.DashmixIconName.EthernetSolid]: 'fas fa-ethernet',
    [Icon_contracts_1.DashmixIconName.EtsyBrand]: 'fab fa-etsy',
    [Icon_contracts_1.DashmixIconName.EuroSignSolid]: 'fas fa-euro-sign',
    [Icon_contracts_1.DashmixIconName.EvernoteBrand]: 'fab fa-evernote',
    [Icon_contracts_1.DashmixIconName.ExchangeAltSolid]: 'fas fa-exchange-alt',
    [Icon_contracts_1.DashmixIconName.ExclamationCircleSolid]: 'fas fa-exclamation-circle',
    [Icon_contracts_1.DashmixIconName.ExclamationSolid]: 'fas fa-exclamation',
    [Icon_contracts_1.DashmixIconName.ExclamationTriangleSolid]: 'fas fa-exclamation-triangle',
    [Icon_contracts_1.DashmixIconName.ExpandAltSolid]: 'fas fa-expand-alt',
    [Icon_contracts_1.DashmixIconName.ExpandArrowsAltSolid]: 'fas fa-expand-arrows-alt',
    [Icon_contracts_1.DashmixIconName.ExpandSolid]: 'fas fa-expand',
    [Icon_contracts_1.DashmixIconName.ExpeditedsslBrand]: 'fab fa-expeditedssl',
    [Icon_contracts_1.DashmixIconName.ExternalLinkAltSolid]: 'fas fa-external-link-alt',
    [Icon_contracts_1.DashmixIconName.ExternalLinkSquareAltSolid]: 'fas fa-external-link-square-alt',
    [Icon_contracts_1.DashmixIconName.EyeDropperSolid]: 'fas fa-eye-dropper',
    [Icon_contracts_1.DashmixIconName.EyeSlashSolid]: 'fas fa-eye-slash',
    [Icon_contracts_1.DashmixIconName.EyeSlash]: 'far fa-eye-slash',
    [Icon_contracts_1.DashmixIconName.EyeSolid]: 'fas fa-eye',
    [Icon_contracts_1.DashmixIconName.Eye]: 'far fa-eye',
    [Icon_contracts_1.DashmixIconName.FacebookBrand]: 'fab fa-facebook',
    [Icon_contracts_1.DashmixIconName.FacebookFBrand]: 'fab fa-facebook-f',
    [Icon_contracts_1.DashmixIconName.FacebookMessengerBrand]: 'fab fa-facebook-messenger',
    [Icon_contracts_1.DashmixIconName.FacebookSquareBrand]: 'fab fa-facebook-square',
    [Icon_contracts_1.DashmixIconName.FanSolid]: 'fas fa-fan',
    [Icon_contracts_1.DashmixIconName.FantasyFlightGamesBrand]: 'fab fa-fantasy-flight-games',
    [Icon_contracts_1.DashmixIconName.FastBackwardSolid]: 'fas fa-fast-backward',
    [Icon_contracts_1.DashmixIconName.FastForwardSolid]: 'fas fa-fast-forward',
    [Icon_contracts_1.DashmixIconName.FaxSolid]: 'fas fa-fax',
    [Icon_contracts_1.DashmixIconName.FeatherAltSolid]: 'fas fa-feather-alt',
    [Icon_contracts_1.DashmixIconName.FeatherSolid]: 'fas fa-feather',
    [Icon_contracts_1.DashmixIconName.FedexBrand]: 'fab fa-fedex',
    [Icon_contracts_1.DashmixIconName.FedoraBrand]: 'fab fa-fedora',
    [Icon_contracts_1.DashmixIconName.FemaleSolid]: 'fas fa-female',
    [Icon_contracts_1.DashmixIconName.FighterJetSolid]: 'fas fa-fighter-jet',
    [Icon_contracts_1.DashmixIconName.FigmaBrand]: 'fab fa-figma',
    [Icon_contracts_1.DashmixIconName.FileAltSolid]: 'fas fa-file-alt',
    [Icon_contracts_1.DashmixIconName.FileAlt]: 'far fa-file-alt',
    [Icon_contracts_1.DashmixIconName.FileArchiveSolid]: 'fas fa-file-archive',
    [Icon_contracts_1.DashmixIconName.FileArchive]: 'far fa-file-archive',
    [Icon_contracts_1.DashmixIconName.FileAudioSolid]: 'fas fa-file-audio',
    [Icon_contracts_1.DashmixIconName.FileAudio]: 'far fa-file-audio',
    [Icon_contracts_1.DashmixIconName.FileCodeSolid]: 'fas fa-file-code',
    [Icon_contracts_1.DashmixIconName.FileCode]: 'far fa-file-code',
    [Icon_contracts_1.DashmixIconName.FileContractSolid]: 'fas fa-file-contract',
    [Icon_contracts_1.DashmixIconName.FileCsvSolid]: 'fas fa-file-csv',
    [Icon_contracts_1.DashmixIconName.FileDownloadSolid]: 'fas fa-file-download',
    [Icon_contracts_1.DashmixIconName.FileExcelSolid]: 'fas fa-file-excel',
    [Icon_contracts_1.DashmixIconName.FileExcel]: 'far fa-file-excel',
    [Icon_contracts_1.DashmixIconName.FileExportSolid]: 'fas fa-file-export',
    [Icon_contracts_1.DashmixIconName.FileImageSolid]: 'fas fa-file-image',
    [Icon_contracts_1.DashmixIconName.FileImage]: 'far fa-file-image',
    [Icon_contracts_1.DashmixIconName.FileImportSolid]: 'fas fa-file-import',
    [Icon_contracts_1.DashmixIconName.FileInvoiceDollarSolid]: 'fas fa-file-invoice-dollar',
    [Icon_contracts_1.DashmixIconName.FileInvoiceSolid]: 'fas fa-file-invoice',
    [Icon_contracts_1.DashmixIconName.FileMedicalAltSolid]: 'fas fa-file-medical-alt',
    [Icon_contracts_1.DashmixIconName.FileMedicalSolid]: 'fas fa-file-medical',
    [Icon_contracts_1.DashmixIconName.FilePdfSolid]: 'fas fa-file-pdf',
    [Icon_contracts_1.DashmixIconName.FilePdf]: 'far fa-file-pdf',
    [Icon_contracts_1.DashmixIconName.FilePowerpointSolid]: 'fas fa-file-powerpoint',
    [Icon_contracts_1.DashmixIconName.FilePowerpoint]: 'far fa-file-powerpoint',
    [Icon_contracts_1.DashmixIconName.FilePrescriptionSolid]: 'fas fa-file-prescription',
    [Icon_contracts_1.DashmixIconName.FileSignatureSolid]: 'fas fa-file-signature',
    [Icon_contracts_1.DashmixIconName.FileSolid]: 'fas fa-file',
    [Icon_contracts_1.DashmixIconName.FileUploadSolid]: 'fas fa-file-upload',
    [Icon_contracts_1.DashmixIconName.FileVideoSolid]: 'fas fa-file-video',
    [Icon_contracts_1.DashmixIconName.FileVideo]: 'far fa-file-video',
    [Icon_contracts_1.DashmixIconName.FileWordSolid]: 'fas fa-file-word',
    [Icon_contracts_1.DashmixIconName.FileWord]: 'far fa-file-word',
    [Icon_contracts_1.DashmixIconName.File]: 'far fa-file',
    [Icon_contracts_1.DashmixIconName.FillDripSolid]: 'fas fa-fill-drip',
    [Icon_contracts_1.DashmixIconName.FillSolid]: 'fas fa-fill',
    [Icon_contracts_1.DashmixIconName.FilmSolid]: 'fas fa-film',
    [Icon_contracts_1.DashmixIconName.FilterSolid]: 'fas fa-filter',
    [Icon_contracts_1.DashmixIconName.FingerprintSolid]: 'fas fa-fingerprint',
    [Icon_contracts_1.DashmixIconName.FireAltSolid]: 'fas fa-fire-alt',
    [Icon_contracts_1.DashmixIconName.FireExtinguisherSolid]: 'fas fa-fire-extinguisher',
    [Icon_contracts_1.DashmixIconName.FireSolid]: 'fas fa-fire',
    [Icon_contracts_1.DashmixIconName.FirefoxBrand]: 'fab fa-firefox',
    [Icon_contracts_1.DashmixIconName.FirefoxBrowserBrand]: 'fab fa-firefox-browser',
    [Icon_contracts_1.DashmixIconName.FirstAidSolid]: 'fas fa-first-aid',
    [Icon_contracts_1.DashmixIconName.FirstOrderAltBrand]: 'fab fa-first-order-alt',
    [Icon_contracts_1.DashmixIconName.FirstOrderBrand]: 'fab fa-first-order',
    [Icon_contracts_1.DashmixIconName.FirstdraftBrand]: 'fab fa-firstdraft',
    [Icon_contracts_1.DashmixIconName.FishSolid]: 'fas fa-fish',
    [Icon_contracts_1.DashmixIconName.FistRaisedSolid]: 'fas fa-fist-raised',
    [Icon_contracts_1.DashmixIconName.FiveHundredPxBrand]: 'fab fa-500px',
    [Icon_contracts_1.DashmixIconName.FlagCheckeredSolid]: 'fas fa-flag-checkered',
    [Icon_contracts_1.DashmixIconName.FlagSolid]: 'fas fa-flag',
    [Icon_contracts_1.DashmixIconName.FlagUsaSolid]: 'fas fa-flag-usa',
    [Icon_contracts_1.DashmixIconName.Flag]: 'far fa-flag',
    [Icon_contracts_1.DashmixIconName.FlaskSolid]: 'fas fa-flask',
    [Icon_contracts_1.DashmixIconName.FlickrBrand]: 'fab fa-flickr',
    [Icon_contracts_1.DashmixIconName.FlipboardBrand]: 'fab fa-flipboard',
    [Icon_contracts_1.DashmixIconName.FlushedSolid]: 'fas fa-flushed',
    [Icon_contracts_1.DashmixIconName.Flushed]: 'far fa-flushed',
    [Icon_contracts_1.DashmixIconName.FlyBrand]: 'fab fa-fly',
    [Icon_contracts_1.DashmixIconName.FolderMinusSolid]: 'fas fa-folder-minus',
    [Icon_contracts_1.DashmixIconName.FolderOpenSolid]: 'fas fa-folder-open',
    [Icon_contracts_1.DashmixIconName.FolderOpen]: 'far fa-folder-open',
    [Icon_contracts_1.DashmixIconName.FolderPlusSolid]: 'fas fa-folder-plus',
    [Icon_contracts_1.DashmixIconName.FolderSolid]: 'fas fa-folder',
    [Icon_contracts_1.DashmixIconName.Folder]: 'far fa-folder',
    [Icon_contracts_1.DashmixIconName.FontAwesomeAltBrand]: 'fab fa-font-awesome-alt',
    [Icon_contracts_1.DashmixIconName.FontAwesomeBrand]: 'fab fa-font-awesome',
    [Icon_contracts_1.DashmixIconName.FontAwesomeFlagBrand]: 'fab fa-font-awesome-flag',
    [Icon_contracts_1.DashmixIconName.FontSolid]: 'fas fa-font',
    [Icon_contracts_1.DashmixIconName.FonticonsBrand]: 'fab fa-fonticons',
    [Icon_contracts_1.DashmixIconName.FonticonsFiBrand]: 'fab fa-fonticons-fi',
    [Icon_contracts_1.DashmixIconName.FootballBallSolid]: 'fas fa-football-ball',
    [Icon_contracts_1.DashmixIconName.FortAwesomeAltBrand]: 'fab fa-fort-awesome-alt',
    [Icon_contracts_1.DashmixIconName.FortAwesomeBrand]: 'fab fa-fort-awesome',
    [Icon_contracts_1.DashmixIconName.ForumbeeBrand]: 'fab fa-forumbee',
    [Icon_contracts_1.DashmixIconName.ForwardSolid]: 'fas fa-forward',
    [Icon_contracts_1.DashmixIconName.FoursquareBrand]: 'fab fa-foursquare',
    [Icon_contracts_1.DashmixIconName.FreeCodeCampBrand]: 'fab fa-free-code-camp',
    [Icon_contracts_1.DashmixIconName.FreebsdBrand]: 'fab fa-freebsd',
    [Icon_contracts_1.DashmixIconName.FrogSolid]: 'fas fa-frog',
    [Icon_contracts_1.DashmixIconName.FrownOpenSolid]: 'fas fa-frown-open',
    [Icon_contracts_1.DashmixIconName.FrownOpen]: 'far fa-frown-open',
    [Icon_contracts_1.DashmixIconName.FrownSolid]: 'fas fa-frown',
    [Icon_contracts_1.DashmixIconName.Frown]: 'far fa-frown',
    [Icon_contracts_1.DashmixIconName.FulcrumBrand]: 'fab fa-fulcrum',
    [Icon_contracts_1.DashmixIconName.FunnelDollarSolid]: 'fas fa-funnel-dollar',
    [Icon_contracts_1.DashmixIconName.FutbolSolid]: 'fas fa-futbol',
    [Icon_contracts_1.DashmixIconName.Futbol]: 'far fa-futbol',
    [Icon_contracts_1.DashmixIconName.GalacticRepublicBrand]: 'fab fa-galactic-republic',
    [Icon_contracts_1.DashmixIconName.GalacticSenateBrand]: 'fab fa-galactic-senate',
    [Icon_contracts_1.DashmixIconName.GamepadSolid]: 'fas fa-gamepad',
    [Icon_contracts_1.DashmixIconName.GasPumpSolid]: 'fas fa-gas-pump',
    [Icon_contracts_1.DashmixIconName.GavelSolid]: 'fas fa-gavel',
    [Icon_contracts_1.DashmixIconName.GemSolid]: 'fas fa-gem',
    [Icon_contracts_1.DashmixIconName.Gem]: 'far fa-gem',
    [Icon_contracts_1.DashmixIconName.GenderlessSolid]: 'fas fa-genderless',
    [Icon_contracts_1.DashmixIconName.GetPocketBrand]: 'fab fa-get-pocket',
    [Icon_contracts_1.DashmixIconName.GgBrand]: 'fab fa-gg',
    [Icon_contracts_1.DashmixIconName.GgCircleBrand]: 'fab fa-gg-circle',
    [Icon_contracts_1.DashmixIconName.GhostSolid]: 'fas fa-ghost',
    [Icon_contracts_1.DashmixIconName.GiftSolid]: 'fas fa-gift',
    [Icon_contracts_1.DashmixIconName.GiftsSolid]: 'fas fa-gifts',
    [Icon_contracts_1.DashmixIconName.GitAltBrand]: 'fab fa-git-alt',
    [Icon_contracts_1.DashmixIconName.GitBrand]: 'fab fa-git',
    [Icon_contracts_1.DashmixIconName.GitSquareBrand]: 'fab fa-git-square',
    [Icon_contracts_1.DashmixIconName.GithubAltBrand]: 'fab fa-github-alt',
    [Icon_contracts_1.DashmixIconName.GithubBrand]: 'fab fa-github',
    [Icon_contracts_1.DashmixIconName.GithubSquareBrand]: 'fab fa-github-square',
    [Icon_contracts_1.DashmixIconName.GitkrakenBrand]: 'fab fa-gitkraken',
    [Icon_contracts_1.DashmixIconName.GitlabBrand]: 'fab fa-gitlab',
    [Icon_contracts_1.DashmixIconName.GitterBrand]: 'fab fa-gitter',
    [Icon_contracts_1.DashmixIconName.GlassCheersSolid]: 'fas fa-glass-cheers',
    [Icon_contracts_1.DashmixIconName.GlassMartiniAltSolid]: 'fas fa-glass-martini-alt',
    [Icon_contracts_1.DashmixIconName.GlassMartiniSolid]: 'fas fa-glass-martini',
    [Icon_contracts_1.DashmixIconName.GlassWhiskeySolid]: 'fas fa-glass-whiskey',
    [Icon_contracts_1.DashmixIconName.GlassesSolid]: 'fas fa-glasses',
    [Icon_contracts_1.DashmixIconName.GlideBrand]: 'fab fa-glide',
    [Icon_contracts_1.DashmixIconName.GlideGBrand]: 'fab fa-glide-g',
    [Icon_contracts_1.DashmixIconName.GlobeAfricaSolid]: 'fas fa-globe-africa',
    [Icon_contracts_1.DashmixIconName.GlobeAmericasSolid]: 'fas fa-globe-americas',
    [Icon_contracts_1.DashmixIconName.GlobeAsiaSolid]: 'fas fa-globe-asia',
    [Icon_contracts_1.DashmixIconName.GlobeEuropeSolid]: 'fas fa-globe-europe',
    [Icon_contracts_1.DashmixIconName.GlobeSolid]: 'fas fa-globe',
    [Icon_contracts_1.DashmixIconName.GoforeBrand]: 'fab fa-gofore',
    [Icon_contracts_1.DashmixIconName.GolfBallSolid]: 'fas fa-golf-ball',
    [Icon_contracts_1.DashmixIconName.GoodreadsBrand]: 'fab fa-goodreads',
    [Icon_contracts_1.DashmixIconName.GoodreadsGBrand]: 'fab fa-goodreads-g',
    [Icon_contracts_1.DashmixIconName.GoogleBrand]: 'fab fa-google',
    [Icon_contracts_1.DashmixIconName.GoogleDriveBrand]: 'fab fa-google-drive',
    [Icon_contracts_1.DashmixIconName.GooglePlayBrand]: 'fab fa-google-play',
    [Icon_contracts_1.DashmixIconName.GooglePlusBrand]: 'fab fa-google-plus',
    [Icon_contracts_1.DashmixIconName.GooglePlusGBrand]: 'fab fa-google-plus-g',
    [Icon_contracts_1.DashmixIconName.GooglePlusSquareBrand]: 'fab fa-google-plus-square',
    [Icon_contracts_1.DashmixIconName.GoogleWalletBrand]: 'fab fa-google-wallet',
    [Icon_contracts_1.DashmixIconName.GopuramSolid]: 'fas fa-gopuram',
    [Icon_contracts_1.DashmixIconName.GraduationCapSolid]: 'fas fa-graduation-cap',
    [Icon_contracts_1.DashmixIconName.GratipayBrand]: 'fab fa-gratipay',
    [Icon_contracts_1.DashmixIconName.GravBrand]: 'fab fa-grav',
    [Icon_contracts_1.DashmixIconName.GreaterThanEqualSolid]: 'fas fa-greater-than-equal',
    [Icon_contracts_1.DashmixIconName.GreaterThanSolid]: 'fas fa-greater-than',
    [Icon_contracts_1.DashmixIconName.GrimaceSolid]: 'fas fa-grimace',
    [Icon_contracts_1.DashmixIconName.Grimace]: 'far fa-grimace',
    [Icon_contracts_1.DashmixIconName.GrinAltSolid]: 'fas fa-grin-alt',
    [Icon_contracts_1.DashmixIconName.GrinAlt]: 'far fa-grin-alt',
    [Icon_contracts_1.DashmixIconName.GrinBeamSolid]: 'fas fa-grin-beam',
    [Icon_contracts_1.DashmixIconName.GrinBeamSweatSolid]: 'fas fa-grin-beam-sweat',
    [Icon_contracts_1.DashmixIconName.GrinBeamSweat]: 'far fa-grin-beam-sweat',
    [Icon_contracts_1.DashmixIconName.GrinBeam]: 'far fa-grin-beam',
    [Icon_contracts_1.DashmixIconName.GrinHeartsSolid]: 'fas fa-grin-hearts',
    [Icon_contracts_1.DashmixIconName.GrinHearts]: 'far fa-grin-hearts',
    [Icon_contracts_1.DashmixIconName.GrinSolid]: 'fas fa-grin',
    [Icon_contracts_1.DashmixIconName.GrinSquintSolid]: 'fas fa-grin-squint',
    [Icon_contracts_1.DashmixIconName.GrinSquintTearsSolid]: 'fas fa-grin-squint-tears',
    [Icon_contracts_1.DashmixIconName.GrinSquintTears]: 'far fa-grin-squint-tears',
    [Icon_contracts_1.DashmixIconName.GrinSquint]: 'far fa-grin-squint',
    [Icon_contracts_1.DashmixIconName.GrinStarsSolid]: 'fas fa-grin-stars',
    [Icon_contracts_1.DashmixIconName.GrinStars]: 'far fa-grin-stars',
    [Icon_contracts_1.DashmixIconName.GrinTearsSolid]: 'fas fa-grin-tears',
    [Icon_contracts_1.DashmixIconName.GrinTears]: 'far fa-grin-tears',
    [Icon_contracts_1.DashmixIconName.GrinTongueSolid]: 'fas fa-grin-tongue',
    [Icon_contracts_1.DashmixIconName.GrinTongueSquintSolid]: 'fas fa-grin-tongue-squint',
    [Icon_contracts_1.DashmixIconName.GrinTongueSquint]: 'far fa-grin-tongue-squint',
    [Icon_contracts_1.DashmixIconName.GrinTongueWinkSolid]: 'fas fa-grin-tongue-wink',
    [Icon_contracts_1.DashmixIconName.GrinTongueWink]: 'far fa-grin-tongue-wink',
    [Icon_contracts_1.DashmixIconName.GrinTongue]: 'far fa-grin-tongue',
    [Icon_contracts_1.DashmixIconName.GrinWinkSolid]: 'fas fa-grin-wink',
    [Icon_contracts_1.DashmixIconName.GrinWink]: 'far fa-grin-wink',
    [Icon_contracts_1.DashmixIconName.Grin]: 'far fa-grin',
    [Icon_contracts_1.DashmixIconName.GripHorizontalSolid]: 'fas fa-grip-horizontal',
    [Icon_contracts_1.DashmixIconName.GripLinesSolid]: 'fas fa-grip-lines',
    [Icon_contracts_1.DashmixIconName.GripLinesVerticalSolid]: 'fas fa-grip-lines-vertical',
    [Icon_contracts_1.DashmixIconName.GripVerticalSolid]: 'fas fa-grip-vertical',
    [Icon_contracts_1.DashmixIconName.GripfireBrand]: 'fab fa-gripfire',
    [Icon_contracts_1.DashmixIconName.GruntBrand]: 'fab fa-grunt',
    [Icon_contracts_1.DashmixIconName.GuitarSolid]: 'fas fa-guitar',
    [Icon_contracts_1.DashmixIconName.GulpBrand]: 'fab fa-gulp',
    [Icon_contracts_1.DashmixIconName.HSquareSolid]: 'fas fa-h-square',
    [Icon_contracts_1.DashmixIconName.HackerNewsBrand]: 'fab fa-hacker-news',
    [Icon_contracts_1.DashmixIconName.HackerNewsSquareBrand]: 'fab fa-hacker-news-square',
    [Icon_contracts_1.DashmixIconName.HackerrankBrand]: 'fab fa-hackerrank',
    [Icon_contracts_1.DashmixIconName.HamburgerSolid]: 'fas fa-hamburger',
    [Icon_contracts_1.DashmixIconName.HammerSolid]: 'fas fa-hammer',
    [Icon_contracts_1.DashmixIconName.HamsaSolid]: 'fas fa-hamsa',
    [Icon_contracts_1.DashmixIconName.HandHoldingHeartSolid]: 'fas fa-hand-holding-heart',
    [Icon_contracts_1.DashmixIconName.HandHoldingSolid]: 'fas fa-hand-holding',
    [Icon_contracts_1.DashmixIconName.HandHoldingUsdSolid]: 'fas fa-hand-holding-usd',
    [Icon_contracts_1.DashmixIconName.HandLizardSolid]: 'fas fa-hand-lizard',
    [Icon_contracts_1.DashmixIconName.HandLizard]: 'far fa-hand-lizard',
    [Icon_contracts_1.DashmixIconName.HandMiddleFingerSolid]: 'fas fa-hand-middle-finger',
    [Icon_contracts_1.DashmixIconName.HandPaperSolid]: 'fas fa-hand-paper',
    [Icon_contracts_1.DashmixIconName.HandPaper]: 'far fa-hand-paper',
    [Icon_contracts_1.DashmixIconName.HandPeaceSolid]: 'fas fa-hand-peace',
    [Icon_contracts_1.DashmixIconName.HandPeace]: 'far fa-hand-peace',
    [Icon_contracts_1.DashmixIconName.HandPointDownSolid]: 'fas fa-hand-point-down',
    [Icon_contracts_1.DashmixIconName.HandPointDown]: 'far fa-hand-point-down',
    [Icon_contracts_1.DashmixIconName.HandPointLeftSolid]: 'fas fa-hand-point-left',
    [Icon_contracts_1.DashmixIconName.HandPointLeft]: 'far fa-hand-point-left',
    [Icon_contracts_1.DashmixIconName.HandPointRightSolid]: 'fas fa-hand-point-right',
    [Icon_contracts_1.DashmixIconName.HandPointRight]: 'far fa-hand-point-right',
    [Icon_contracts_1.DashmixIconName.HandPointUpSolid]: 'fas fa-hand-point-up',
    [Icon_contracts_1.DashmixIconName.HandPointUp]: 'far fa-hand-point-up',
    [Icon_contracts_1.DashmixIconName.HandPointerSolid]: 'fas fa-hand-pointer',
    [Icon_contracts_1.DashmixIconName.HandPointer]: 'far fa-hand-pointer',
    [Icon_contracts_1.DashmixIconName.HandRockSolid]: 'fas fa-hand-rock',
    [Icon_contracts_1.DashmixIconName.HandRock]: 'far fa-hand-rock',
    [Icon_contracts_1.DashmixIconName.HandScissorsSolid]: 'fas fa-hand-scissors',
    [Icon_contracts_1.DashmixIconName.HandScissors]: 'far fa-hand-scissors',
    [Icon_contracts_1.DashmixIconName.HandSpockSolid]: 'fas fa-hand-spock',
    [Icon_contracts_1.DashmixIconName.HandSpock]: 'far fa-hand-spock',
    [Icon_contracts_1.DashmixIconName.HandsHelpingSolid]: 'fas fa-hands-helping',
    [Icon_contracts_1.DashmixIconName.HandsSolid]: 'fas fa-hands',
    [Icon_contracts_1.DashmixIconName.HandshakeSolid]: 'fas fa-handshake',
    [Icon_contracts_1.DashmixIconName.Handshake]: 'far fa-handshake',
    [Icon_contracts_1.DashmixIconName.HanukiahSolid]: 'fas fa-hanukiah',
    [Icon_contracts_1.DashmixIconName.HardHatSolid]: 'fas fa-hard-hat',
    [Icon_contracts_1.DashmixIconName.HashtagSolid]: 'fas fa-hashtag',
    [Icon_contracts_1.DashmixIconName.HatCowboySideSolid]: 'fas fa-hat-cowboy-side',
    [Icon_contracts_1.DashmixIconName.HatCowboySolid]: 'fas fa-hat-cowboy',
    [Icon_contracts_1.DashmixIconName.HatWizardSolid]: 'fas fa-hat-wizard',
    [Icon_contracts_1.DashmixIconName.HddSolid]: 'fas fa-hdd',
    [Icon_contracts_1.DashmixIconName.Hdd]: 'far fa-hdd',
    [Icon_contracts_1.DashmixIconName.HeadingSolid]: 'fas fa-heading',
    [Icon_contracts_1.DashmixIconName.HeadphonesAltSolid]: 'fas fa-headphones-alt',
    [Icon_contracts_1.DashmixIconName.HeadphonesSolid]: 'fas fa-headphones',
    [Icon_contracts_1.DashmixIconName.HeadsetSolid]: 'fas fa-headset',
    [Icon_contracts_1.DashmixIconName.HeartBrokenSolid]: 'fas fa-heart-broken',
    [Icon_contracts_1.DashmixIconName.HeartSolid]: 'fas fa-heart',
    [Icon_contracts_1.DashmixIconName.Heart]: 'far fa-heart',
    [Icon_contracts_1.DashmixIconName.HeartbeatSolid]: 'fas fa-heartbeat',
    [Icon_contracts_1.DashmixIconName.HelicopterSolid]: 'fas fa-helicopter',
    [Icon_contracts_1.DashmixIconName.HighlighterSolid]: 'fas fa-highlighter',
    [Icon_contracts_1.DashmixIconName.HikingSolid]: 'fas fa-hiking',
    [Icon_contracts_1.DashmixIconName.HippoSolid]: 'fas fa-hippo',
    [Icon_contracts_1.DashmixIconName.HipsBrand]: 'fab fa-hips',
    [Icon_contracts_1.DashmixIconName.HireAHelperBrand]: 'fab fa-hire-a-helper',
    [Icon_contracts_1.DashmixIconName.HistorySolid]: 'fas fa-history',
    [Icon_contracts_1.DashmixIconName.HockeyPuckSolid]: 'fas fa-hockey-puck',
    [Icon_contracts_1.DashmixIconName.HollyBerrySolid]: 'fas fa-holly-berry',
    [Icon_contracts_1.DashmixIconName.HomeSolid]: 'fas fa-home',
    [Icon_contracts_1.DashmixIconName.HooliBrand]: 'fab fa-hooli',
    [Icon_contracts_1.DashmixIconName.HornbillBrand]: 'fab fa-hornbill',
    [Icon_contracts_1.DashmixIconName.HorseHeadSolid]: 'fas fa-horse-head',
    [Icon_contracts_1.DashmixIconName.HorseSolid]: 'fas fa-horse',
    [Icon_contracts_1.DashmixIconName.HospitalAltSolid]: 'fas fa-hospital-alt',
    [Icon_contracts_1.DashmixIconName.HospitalSolid]: 'fas fa-hospital',
    [Icon_contracts_1.DashmixIconName.HospitalSymbolSolid]: 'fas fa-hospital-symbol',
    [Icon_contracts_1.DashmixIconName.Hospital]: 'far fa-hospital',
    [Icon_contracts_1.DashmixIconName.HotTubSolid]: 'fas fa-hot-tub',
    [Icon_contracts_1.DashmixIconName.HotdogSolid]: 'fas fa-hotdog',
    [Icon_contracts_1.DashmixIconName.HotelSolid]: 'fas fa-hotel',
    [Icon_contracts_1.DashmixIconName.HotjarBrand]: 'fab fa-hotjar',
    [Icon_contracts_1.DashmixIconName.HourglassEndSolid]: 'fas fa-hourglass-end',
    [Icon_contracts_1.DashmixIconName.HourglassHalfSolid]: 'fas fa-hourglass-half',
    [Icon_contracts_1.DashmixIconName.HourglassSolid]: 'fas fa-hourglass',
    [Icon_contracts_1.DashmixIconName.HourglassStartSolid]: 'fas fa-hourglass-start',
    [Icon_contracts_1.DashmixIconName.Hourglass]: 'far fa-hourglass',
    [Icon_contracts_1.DashmixIconName.HouseDamageSolid]: 'fas fa-house-damage',
    [Icon_contracts_1.DashmixIconName.HouzzBrand]: 'fab fa-houzz',
    [Icon_contracts_1.DashmixIconName.HryvniaSolid]: 'fas fa-hryvnia',
    [Icon_contracts_1.DashmixIconName.Html5Brand]: 'fab fa-html5',
    [Icon_contracts_1.DashmixIconName.HubspotBrand]: 'fab fa-hubspot',
    [Icon_contracts_1.DashmixIconName.ICursorSolid]: 'fas fa-i-cursor',
    [Icon_contracts_1.DashmixIconName.IceCreamSolid]: 'fas fa-ice-cream',
    [Icon_contracts_1.DashmixIconName.IciclesSolid]: 'fas fa-icicles',
    [Icon_contracts_1.DashmixIconName.IconsSolid]: 'fas fa-icons',
    [Icon_contracts_1.DashmixIconName.IdBadgeSolid]: 'fas fa-id-badge',
    [Icon_contracts_1.DashmixIconName.IdBadge]: 'far fa-id-badge',
    [Icon_contracts_1.DashmixIconName.IdCardAltSolid]: 'fas fa-id-card-alt',
    [Icon_contracts_1.DashmixIconName.IdCardSolid]: 'fas fa-id-card',
    [Icon_contracts_1.DashmixIconName.IdCard]: 'far fa-id-card',
    [Icon_contracts_1.DashmixIconName.IdealBrand]: 'fab fa-ideal',
    [Icon_contracts_1.DashmixIconName.IglooSolid]: 'fas fa-igloo',
    [Icon_contracts_1.DashmixIconName.ImageSolid]: 'fas fa-image',
    [Icon_contracts_1.DashmixIconName.Image]: 'far fa-image',
    [Icon_contracts_1.DashmixIconName.ImagesSolid]: 'fas fa-images',
    [Icon_contracts_1.DashmixIconName.Images]: 'far fa-images',
    [Icon_contracts_1.DashmixIconName.ImdbBrand]: 'fab fa-imdb',
    [Icon_contracts_1.DashmixIconName.InboxSolid]: 'fas fa-inbox',
    [Icon_contracts_1.DashmixIconName.IndentSolid]: 'fas fa-indent',
    [Icon_contracts_1.DashmixIconName.IndustrySolid]: 'fas fa-industry',
    [Icon_contracts_1.DashmixIconName.InfinitySolid]: 'fas fa-infinity',
    [Icon_contracts_1.DashmixIconName.InfoCircleSolid]: 'fas fa-info-circle',
    [Icon_contracts_1.DashmixIconName.InfoSolid]: 'fas fa-info',
    [Icon_contracts_1.DashmixIconName.InstagramBrand]: 'fab fa-instagram',
    [Icon_contracts_1.DashmixIconName.InstagramSquareBrand]: 'fab fa-instagram-square',
    [Icon_contracts_1.DashmixIconName.IntercomBrand]: 'fab fa-intercom',
    [Icon_contracts_1.DashmixIconName.InternetExplorerBrand]: 'fab fa-internet-explorer',
    [Icon_contracts_1.DashmixIconName.InvisionBrand]: 'fab fa-invision',
    [Icon_contracts_1.DashmixIconName.IoxhostBrand]: 'fab fa-ioxhost',
    [Icon_contracts_1.DashmixIconName.ItalicSolid]: 'fas fa-italic',
    [Icon_contracts_1.DashmixIconName.ItchIoBrand]: 'fab fa-itch-io',
    [Icon_contracts_1.DashmixIconName.ItunesBrand]: 'fab fa-itunes',
    [Icon_contracts_1.DashmixIconName.ItunesNoteBrand]: 'fab fa-itunes-note',
    [Icon_contracts_1.DashmixIconName.JavaBrand]: 'fab fa-java',
    [Icon_contracts_1.DashmixIconName.JediOrderBrand]: 'fab fa-jedi-order',
    [Icon_contracts_1.DashmixIconName.JediSolid]: 'fas fa-jedi',
    [Icon_contracts_1.DashmixIconName.JenkinsBrand]: 'fab fa-jenkins',
    [Icon_contracts_1.DashmixIconName.JiraBrand]: 'fab fa-jira',
    [Icon_contracts_1.DashmixIconName.JogetBrand]: 'fab fa-joget',
    [Icon_contracts_1.DashmixIconName.JointSolid]: 'fas fa-joint',
    [Icon_contracts_1.DashmixIconName.JoomlaBrand]: 'fab fa-joomla',
    [Icon_contracts_1.DashmixIconName.JournalWhillsSolid]: 'fas fa-journal-whills',
    [Icon_contracts_1.DashmixIconName.JsBrand]: 'fab fa-js',
    [Icon_contracts_1.DashmixIconName.JsSquareBrand]: 'fab fa-js-square',
    [Icon_contracts_1.DashmixIconName.JsfiddleBrand]: 'fab fa-jsfiddle',
    [Icon_contracts_1.DashmixIconName.KaabaSolid]: 'fas fa-kaaba',
    [Icon_contracts_1.DashmixIconName.KaggleBrand]: 'fab fa-kaggle',
    [Icon_contracts_1.DashmixIconName.KeySolid]: 'fas fa-key',
    [Icon_contracts_1.DashmixIconName.KeybaseBrand]: 'fab fa-keybase',
    [Icon_contracts_1.DashmixIconName.KeyboardSolid]: 'fas fa-keyboard',
    [Icon_contracts_1.DashmixIconName.Keyboard]: 'far fa-keyboard',
    [Icon_contracts_1.DashmixIconName.KeycdnBrand]: 'fab fa-keycdn',
    [Icon_contracts_1.DashmixIconName.KhandaSolid]: 'fas fa-khanda',
    [Icon_contracts_1.DashmixIconName.KickstarterBrand]: 'fab fa-kickstarter',
    [Icon_contracts_1.DashmixIconName.KickstarterKBrand]: 'fab fa-kickstarter-k',
    [Icon_contracts_1.DashmixIconName.KissBeamSolid]: 'fas fa-kiss-beam',
    [Icon_contracts_1.DashmixIconName.KissBeam]: 'far fa-kiss-beam',
    [Icon_contracts_1.DashmixIconName.KissSolid]: 'fas fa-kiss',
    [Icon_contracts_1.DashmixIconName.KissWinkHeartSolid]: 'fas fa-kiss-wink-heart',
    [Icon_contracts_1.DashmixIconName.KissWinkHeart]: 'far fa-kiss-wink-heart',
    [Icon_contracts_1.DashmixIconName.Kiss]: 'far fa-kiss',
    [Icon_contracts_1.DashmixIconName.KiwiBirdSolid]: 'fas fa-kiwi-bird',
    [Icon_contracts_1.DashmixIconName.KorvueBrand]: 'fab fa-korvue',
    [Icon_contracts_1.DashmixIconName.LandmarkSolid]: 'fas fa-landmark',
    [Icon_contracts_1.DashmixIconName.LanguageSolid]: 'fas fa-language',
    [Icon_contracts_1.DashmixIconName.LaptopCodeSolid]: 'fas fa-laptop-code',
    [Icon_contracts_1.DashmixIconName.LaptopMedicalSolid]: 'fas fa-laptop-medical',
    [Icon_contracts_1.DashmixIconName.LaptopSolid]: 'fas fa-laptop',
    [Icon_contracts_1.DashmixIconName.LaravelBrand]: 'fab fa-laravel',
    [Icon_contracts_1.DashmixIconName.LastfmBrand]: 'fab fa-lastfm',
    [Icon_contracts_1.DashmixIconName.LastfmSquareBrand]: 'fab fa-lastfm-square',
    [Icon_contracts_1.DashmixIconName.LaughBeamSolid]: 'fas fa-laugh-beam',
    [Icon_contracts_1.DashmixIconName.LaughBeam]: 'far fa-laugh-beam',
    [Icon_contracts_1.DashmixIconName.LaughSolid]: 'fas fa-laugh',
    [Icon_contracts_1.DashmixIconName.LaughSquintSolid]: 'fas fa-laugh-squint',
    [Icon_contracts_1.DashmixIconName.LaughSquint]: 'far fa-laugh-squint',
    [Icon_contracts_1.DashmixIconName.LaughWinkSolid]: 'fas fa-laugh-wink',
    [Icon_contracts_1.DashmixIconName.LaughWink]: 'far fa-laugh-wink',
    [Icon_contracts_1.DashmixIconName.Laugh]: 'far fa-laugh',
    [Icon_contracts_1.DashmixIconName.LayerGroupSolid]: 'fas fa-layer-group',
    [Icon_contracts_1.DashmixIconName.LeafSolid]: 'fas fa-leaf',
    [Icon_contracts_1.DashmixIconName.LeanpubBrand]: 'fab fa-leanpub',
    [Icon_contracts_1.DashmixIconName.LemonSolid]: 'fas fa-lemon',
    [Icon_contracts_1.DashmixIconName.Lemon]: 'far fa-lemon',
    [Icon_contracts_1.DashmixIconName.LessBrand]: 'fab fa-less',
    [Icon_contracts_1.DashmixIconName.LessThanEqualSolid]: 'fas fa-less-than-equal',
    [Icon_contracts_1.DashmixIconName.LessThanSolid]: 'fas fa-less-than',
    [Icon_contracts_1.DashmixIconName.LevelDownAltSolid]: 'fas fa-level-down-alt',
    [Icon_contracts_1.DashmixIconName.LevelUpAltSolid]: 'fas fa-level-up-alt',
    [Icon_contracts_1.DashmixIconName.LifeRingSolid]: 'fas fa-life-ring',
    [Icon_contracts_1.DashmixIconName.LifeRing]: 'far fa-life-ring',
    [Icon_contracts_1.DashmixIconName.LightbulbSolid]: 'fas fa-lightbulb',
    [Icon_contracts_1.DashmixIconName.Lightbulb]: 'far fa-lightbulb',
    [Icon_contracts_1.DashmixIconName.LineBrand]: 'fab fa-line',
    [Icon_contracts_1.DashmixIconName.LinkSolid]: 'fas fa-link',
    [Icon_contracts_1.DashmixIconName.LinkedinBrand]: 'fab fa-linkedin',
    [Icon_contracts_1.DashmixIconName.LinkedinInBrand]: 'fab fa-linkedin-in',
    [Icon_contracts_1.DashmixIconName.LinodeBrand]: 'fab fa-linode',
    [Icon_contracts_1.DashmixIconName.LinuxBrand]: 'fab fa-linux',
    [Icon_contracts_1.DashmixIconName.LiraSignSolid]: 'fas fa-lira-sign',
    [Icon_contracts_1.DashmixIconName.ListAltSolid]: 'fas fa-list-alt',
    [Icon_contracts_1.DashmixIconName.ListAlt]: 'far fa-list-alt',
    [Icon_contracts_1.DashmixIconName.ListOlSolid]: 'fas fa-list-ol',
    [Icon_contracts_1.DashmixIconName.ListSolid]: 'fas fa-list',
    [Icon_contracts_1.DashmixIconName.ListUlSolid]: 'fas fa-list-ul',
    [Icon_contracts_1.DashmixIconName.LocationArrowSolid]: 'fas fa-location-arrow',
    [Icon_contracts_1.DashmixIconName.LockOpenSolid]: 'fas fa-lock-open',
    [Icon_contracts_1.DashmixIconName.LockSolid]: 'fas fa-lock',
    [Icon_contracts_1.DashmixIconName.LongArrowAltDownSolid]: 'fas fa-long-arrow-alt-down',
    [Icon_contracts_1.DashmixIconName.LongArrowAltLeftSolid]: 'fas fa-long-arrow-alt-left',
    [Icon_contracts_1.DashmixIconName.LongArrowAltRightSolid]: 'fas fa-long-arrow-alt-right',
    [Icon_contracts_1.DashmixIconName.LongArrowAltUpSolid]: 'fas fa-long-arrow-alt-up',
    [Icon_contracts_1.DashmixIconName.LowVisionSolid]: 'fas fa-low-vision',
    [Icon_contracts_1.DashmixIconName.LuggageCartSolid]: 'fas fa-luggage-cart',
    [Icon_contracts_1.DashmixIconName.LyftBrand]: 'fab fa-lyft',
    [Icon_contracts_1.DashmixIconName.MagentoBrand]: 'fab fa-magento',
    [Icon_contracts_1.DashmixIconName.MagicSolid]: 'fas fa-magic',
    [Icon_contracts_1.DashmixIconName.MagnetSolid]: 'fas fa-magnet',
    [Icon_contracts_1.DashmixIconName.MailBulkSolid]: 'fas fa-mail-bulk',
    [Icon_contracts_1.DashmixIconName.MailchimpBrand]: 'fab fa-mailchimp',
    [Icon_contracts_1.DashmixIconName.MaleSolid]: 'fas fa-male',
    [Icon_contracts_1.DashmixIconName.MandalorianBrand]: 'fab fa-mandalorian',
    [Icon_contracts_1.DashmixIconName.MapMarkedAltSolid]: 'fas fa-map-marked-alt',
    [Icon_contracts_1.DashmixIconName.MapMarkedSolid]: 'fas fa-map-marked',
    [Icon_contracts_1.DashmixIconName.MapMarkerAltSolid]: 'fas fa-map-marker-alt',
    [Icon_contracts_1.DashmixIconName.MapMarkerSolid]: 'fas fa-map-marker',
    [Icon_contracts_1.DashmixIconName.MapPinSolid]: 'fas fa-map-pin',
    [Icon_contracts_1.DashmixIconName.MapSignsSolid]: 'fas fa-map-signs',
    [Icon_contracts_1.DashmixIconName.MapSolid]: 'fas fa-map',
    [Icon_contracts_1.DashmixIconName.Map]: 'far fa-map',
    [Icon_contracts_1.DashmixIconName.MarkdownBrand]: 'fab fa-markdown',
    [Icon_contracts_1.DashmixIconName.MarkerSolid]: 'fas fa-marker',
    [Icon_contracts_1.DashmixIconName.MarsDoubleSolid]: 'fas fa-mars-double',
    [Icon_contracts_1.DashmixIconName.MarsSolid]: 'fas fa-mars',
    [Icon_contracts_1.DashmixIconName.MarsStrokeHSolid]: 'fas fa-mars-stroke-h',
    [Icon_contracts_1.DashmixIconName.MarsStrokeSolid]: 'fas fa-mars-stroke',
    [Icon_contracts_1.DashmixIconName.MarsStrokeVSolid]: 'fas fa-mars-stroke-v',
    [Icon_contracts_1.DashmixIconName.MaskSolid]: 'fas fa-mask',
    [Icon_contracts_1.DashmixIconName.MastodonBrand]: 'fab fa-mastodon',
    [Icon_contracts_1.DashmixIconName.MaxcdnBrand]: 'fab fa-maxcdn',
    [Icon_contracts_1.DashmixIconName.MdbBrand]: 'fab fa-mdb',
    [Icon_contracts_1.DashmixIconName.MedalSolid]: 'fas fa-medal',
    [Icon_contracts_1.DashmixIconName.MedappsBrand]: 'fab fa-medapps',
    [Icon_contracts_1.DashmixIconName.MediumBrand]: 'fab fa-medium',
    [Icon_contracts_1.DashmixIconName.MediumMBrand]: 'fab fa-medium-m',
    [Icon_contracts_1.DashmixIconName.MedkitSolid]: 'fas fa-medkit',
    [Icon_contracts_1.DashmixIconName.MedrtBrand]: 'fab fa-medrt',
    [Icon_contracts_1.DashmixIconName.MeetupBrand]: 'fab fa-meetup',
    [Icon_contracts_1.DashmixIconName.MegaportBrand]: 'fab fa-megaport',
    [Icon_contracts_1.DashmixIconName.MehBlankSolid]: 'fas fa-meh-blank',
    [Icon_contracts_1.DashmixIconName.MehBlank]: 'far fa-meh-blank',
    [Icon_contracts_1.DashmixIconName.MehRollingEyesSolid]: 'fas fa-meh-rolling-eyes',
    [Icon_contracts_1.DashmixIconName.MehRollingEyes]: 'far fa-meh-rolling-eyes',
    [Icon_contracts_1.DashmixIconName.MehSolid]: 'fas fa-meh',
    [Icon_contracts_1.DashmixIconName.Meh]: 'far fa-meh',
    [Icon_contracts_1.DashmixIconName.MemorySolid]: 'fas fa-memory',
    [Icon_contracts_1.DashmixIconName.MendeleyBrand]: 'fab fa-mendeley',
    [Icon_contracts_1.DashmixIconName.MenorahSolid]: 'fas fa-menorah',
    [Icon_contracts_1.DashmixIconName.MercurySolid]: 'fas fa-mercury',
    [Icon_contracts_1.DashmixIconName.MeteorSolid]: 'fas fa-meteor',
    [Icon_contracts_1.DashmixIconName.MicroblogBrand]: 'fab fa-microblog',
    [Icon_contracts_1.DashmixIconName.MicrochipSolid]: 'fas fa-microchip',
    [Icon_contracts_1.DashmixIconName.MicrophoneAltSlashSolid]: 'fas fa-microphone-alt-slash',
    [Icon_contracts_1.DashmixIconName.MicrophoneAltSolid]: 'fas fa-microphone-alt',
    [Icon_contracts_1.DashmixIconName.MicrophoneSlashSolid]: 'fas fa-microphone-slash',
    [Icon_contracts_1.DashmixIconName.MicrophoneSolid]: 'fas fa-microphone',
    [Icon_contracts_1.DashmixIconName.MicroscopeSolid]: 'fas fa-microscope',
    [Icon_contracts_1.DashmixIconName.MicrosoftBrand]: 'fab fa-microsoft',
    [Icon_contracts_1.DashmixIconName.MinusCircleSolid]: 'fas fa-minus-circle',
    [Icon_contracts_1.DashmixIconName.MinusSolid]: 'fas fa-minus',
    [Icon_contracts_1.DashmixIconName.MinusSquareSolid]: 'fas fa-minus-square',
    [Icon_contracts_1.DashmixIconName.MinusSquare]: 'far fa-minus-square',
    [Icon_contracts_1.DashmixIconName.MittenSolid]: 'fas fa-mitten',
    [Icon_contracts_1.DashmixIconName.MixBrand]: 'fab fa-mix',
    [Icon_contracts_1.DashmixIconName.MixcloudBrand]: 'fab fa-mixcloud',
    [Icon_contracts_1.DashmixIconName.MixerBrand]: 'fab fa-mixer',
    [Icon_contracts_1.DashmixIconName.MizuniBrand]: 'fab fa-mizuni',
    [Icon_contracts_1.DashmixIconName.MobileAltSolid]: 'fas fa-mobile-alt',
    [Icon_contracts_1.DashmixIconName.MobileSolid]: 'fas fa-mobile',
    [Icon_contracts_1.DashmixIconName.ModxBrand]: 'fab fa-modx',
    [Icon_contracts_1.DashmixIconName.MoneroBrand]: 'fab fa-monero',
    [Icon_contracts_1.DashmixIconName.MoneyBillAltSolid]: 'fas fa-money-bill-alt',
    [Icon_contracts_1.DashmixIconName.MoneyBillAlt]: 'far fa-money-bill-alt',
    [Icon_contracts_1.DashmixIconName.MoneyBillSolid]: 'fas fa-money-bill',
    [Icon_contracts_1.DashmixIconName.MoneyBillWaveAltSolid]: 'fas fa-money-bill-wave-alt',
    [Icon_contracts_1.DashmixIconName.MoneyBillWaveSolid]: 'fas fa-money-bill-wave',
    [Icon_contracts_1.DashmixIconName.MoneyCheckAltSolid]: 'fas fa-money-check-alt',
    [Icon_contracts_1.DashmixIconName.MoneyCheckSolid]: 'fas fa-money-check',
    [Icon_contracts_1.DashmixIconName.MonumentSolid]: 'fas fa-monument',
    [Icon_contracts_1.DashmixIconName.MoonSolid]: 'fas fa-moon',
    [Icon_contracts_1.DashmixIconName.Moon]: 'far fa-moon',
    [Icon_contracts_1.DashmixIconName.MortarPestleSolid]: 'fas fa-mortar-pestle',
    [Icon_contracts_1.DashmixIconName.MosqueSolid]: 'fas fa-mosque',
    [Icon_contracts_1.DashmixIconName.MotorcycleSolid]: 'fas fa-motorcycle',
    [Icon_contracts_1.DashmixIconName.MountainSolid]: 'fas fa-mountain',
    [Icon_contracts_1.DashmixIconName.MousePointerSolid]: 'fas fa-mouse-pointer',
    [Icon_contracts_1.DashmixIconName.MouseSolid]: 'fas fa-mouse',
    [Icon_contracts_1.DashmixIconName.MugHotSolid]: 'fas fa-mug-hot',
    [Icon_contracts_1.DashmixIconName.MusicSolid]: 'fas fa-music',
    [Icon_contracts_1.DashmixIconName.NapsterBrand]: 'fab fa-napster',
    [Icon_contracts_1.DashmixIconName.NeosBrand]: 'fab fa-neos',
    [Icon_contracts_1.DashmixIconName.NetworkWiredSolid]: 'fas fa-network-wired',
    [Icon_contracts_1.DashmixIconName.NeuterSolid]: 'fas fa-neuter',
    [Icon_contracts_1.DashmixIconName.NewspaperSolid]: 'fas fa-newspaper',
    [Icon_contracts_1.DashmixIconName.Newspaper]: 'far fa-newspaper',
    [Icon_contracts_1.DashmixIconName.NimblrBrand]: 'fab fa-nimblr',
    [Icon_contracts_1.DashmixIconName.NodeBrand]: 'fab fa-node',
    [Icon_contracts_1.DashmixIconName.NodeJsBrand]: 'fab fa-node-js',
    [Icon_contracts_1.DashmixIconName.NotEqualSolid]: 'fas fa-not-equal',
    [Icon_contracts_1.DashmixIconName.NotesMedicalSolid]: 'fas fa-notes-medical',
    [Icon_contracts_1.DashmixIconName.NpmBrand]: 'fab fa-npm',
    [Icon_contracts_1.DashmixIconName.Ns8Brand]: 'fab fa-ns8',
    [Icon_contracts_1.DashmixIconName.NutritionixBrand]: 'fab fa-nutritionix',
    [Icon_contracts_1.DashmixIconName.ObjectGroupSolid]: 'fas fa-object-group',
    [Icon_contracts_1.DashmixIconName.ObjectGroup]: 'far fa-object-group',
    [Icon_contracts_1.DashmixIconName.ObjectUngroupSolid]: 'fas fa-object-ungroup',
    [Icon_contracts_1.DashmixIconName.ObjectUngroup]: 'far fa-object-ungroup',
    [Icon_contracts_1.DashmixIconName.OdnoklassnikiBrand]: 'fab fa-odnoklassniki',
    [Icon_contracts_1.DashmixIconName.OdnoklassnikiSquareBrand]: 'fab fa-odnoklassniki-square',
    [Icon_contracts_1.DashmixIconName.OilCanSolid]: 'fas fa-oil-can',
    [Icon_contracts_1.DashmixIconName.OldRepublicBrand]: 'fab fa-old-republic',
    [Icon_contracts_1.DashmixIconName.OmSolid]: 'fas fa-om',
    [Icon_contracts_1.DashmixIconName.OpencartBrand]: 'fab fa-opencart',
    [Icon_contracts_1.DashmixIconName.OpenidBrand]: 'fab fa-openid',
    [Icon_contracts_1.DashmixIconName.OperaBrand]: 'fab fa-opera',
    [Icon_contracts_1.DashmixIconName.OptinMonsterBrand]: 'fab fa-optin-monster',
    [Icon_contracts_1.DashmixIconName.OrcidBrand]: 'fab fa-orcid',
    [Icon_contracts_1.DashmixIconName.OsiBrand]: 'fab fa-osi',
    [Icon_contracts_1.DashmixIconName.OtterSolid]: 'fas fa-otter',
    [Icon_contracts_1.DashmixIconName.OutdentSolid]: 'fas fa-outdent',
    [Icon_contracts_1.DashmixIconName.Page4Brand]: 'fab fa-page4',
    [Icon_contracts_1.DashmixIconName.PagelinesBrand]: 'fab fa-pagelines',
    [Icon_contracts_1.DashmixIconName.PagerSolid]: 'fas fa-pager',
    [Icon_contracts_1.DashmixIconName.PaintBrushSolid]: 'fas fa-paint-brush',
    [Icon_contracts_1.DashmixIconName.PaintRollerSolid]: 'fas fa-paint-roller',
    [Icon_contracts_1.DashmixIconName.PaletteSolid]: 'fas fa-palette',
    [Icon_contracts_1.DashmixIconName.PalfedBrand]: 'fab fa-palfed',
    [Icon_contracts_1.DashmixIconName.PalletSolid]: 'fas fa-pallet',
    [Icon_contracts_1.DashmixIconName.PaperPlaneSolid]: 'fas fa-paper-plane',
    [Icon_contracts_1.DashmixIconName.PaperPlane]: 'far fa-paper-plane',
    [Icon_contracts_1.DashmixIconName.PaperclipSolid]: 'fas fa-paperclip',
    [Icon_contracts_1.DashmixIconName.ParachuteBoxSolid]: 'fas fa-parachute-box',
    [Icon_contracts_1.DashmixIconName.ParagraphSolid]: 'fas fa-paragraph',
    [Icon_contracts_1.DashmixIconName.ParkingSolid]: 'fas fa-parking',
    [Icon_contracts_1.DashmixIconName.PassportSolid]: 'fas fa-passport',
    [Icon_contracts_1.DashmixIconName.PastafarianismSolid]: 'fas fa-pastafarianism',
    [Icon_contracts_1.DashmixIconName.PasteSolid]: 'fas fa-paste',
    [Icon_contracts_1.DashmixIconName.PatreonBrand]: 'fab fa-patreon',
    [Icon_contracts_1.DashmixIconName.PauseCircleSolid]: 'fas fa-pause-circle',
    [Icon_contracts_1.DashmixIconName.PauseCircle]: 'far fa-pause-circle',
    [Icon_contracts_1.DashmixIconName.PauseSolid]: 'fas fa-pause',
    [Icon_contracts_1.DashmixIconName.PawSolid]: 'fas fa-paw',
    [Icon_contracts_1.DashmixIconName.PaypalBrand]: 'fab fa-paypal',
    [Icon_contracts_1.DashmixIconName.PeaceSolid]: 'fas fa-peace',
    [Icon_contracts_1.DashmixIconName.PenAltSolid]: 'fas fa-pen-alt',
    [Icon_contracts_1.DashmixIconName.PenFancySolid]: 'fas fa-pen-fancy',
    [Icon_contracts_1.DashmixIconName.PenNibSolid]: 'fas fa-pen-nib',
    [Icon_contracts_1.DashmixIconName.PenSolid]: 'fas fa-pen',
    [Icon_contracts_1.DashmixIconName.PenSquareSolid]: 'fas fa-pen-square',
    [Icon_contracts_1.DashmixIconName.PencilAltSolid]: 'fas fa-pencil-alt',
    [Icon_contracts_1.DashmixIconName.PencilRulerSolid]: 'fas fa-pencil-ruler',
    [Icon_contracts_1.DashmixIconName.PennyArcadeBrand]: 'fab fa-penny-arcade',
    [Icon_contracts_1.DashmixIconName.PeopleCarrySolid]: 'fas fa-people-carry',
    [Icon_contracts_1.DashmixIconName.PepperHotSolid]: 'fas fa-pepper-hot',
    [Icon_contracts_1.DashmixIconName.PercentSolid]: 'fas fa-percent',
    [Icon_contracts_1.DashmixIconName.PercentageSolid]: 'fas fa-percentage',
    [Icon_contracts_1.DashmixIconName.PeriscopeBrand]: 'fab fa-periscope',
    [Icon_contracts_1.DashmixIconName.PersonBoothSolid]: 'fas fa-person-booth',
    [Icon_contracts_1.DashmixIconName.PhabricatorBrand]: 'fab fa-phabricator',
    [Icon_contracts_1.DashmixIconName.PhoenixFrameworkBrand]: 'fab fa-phoenix-framework',
    [Icon_contracts_1.DashmixIconName.PhoenixSquadronBrand]: 'fab fa-phoenix-squadron',
    [Icon_contracts_1.DashmixIconName.PhoneAltSolid]: 'fas fa-phone-alt',
    [Icon_contracts_1.DashmixIconName.PhoneSlashSolid]: 'fas fa-phone-slash',
    [Icon_contracts_1.DashmixIconName.PhoneSolid]: 'fas fa-phone',
    [Icon_contracts_1.DashmixIconName.PhoneSquareAltSolid]: 'fas fa-phone-square-alt',
    [Icon_contracts_1.DashmixIconName.PhoneSquareSolid]: 'fas fa-phone-square',
    [Icon_contracts_1.DashmixIconName.PhoneVolumeSolid]: 'fas fa-phone-volume',
    [Icon_contracts_1.DashmixIconName.PhotoVideoSolid]: 'fas fa-photo-video',
    [Icon_contracts_1.DashmixIconName.PhpBrand]: 'fab fa-php',
    [Icon_contracts_1.DashmixIconName.PiedPiperAltBrand]: 'fab fa-pied-piper-alt',
    [Icon_contracts_1.DashmixIconName.PiedPiperBrand]: 'fab fa-pied-piper',
    [Icon_contracts_1.DashmixIconName.PiedPiperHatBrand]: 'fab fa-pied-piper-hat',
    [Icon_contracts_1.DashmixIconName.PiedPiperPpBrand]: 'fab fa-pied-piper-pp',
    [Icon_contracts_1.DashmixIconName.PiedPiperSquareBrand]: 'fab fa-pied-piper-square',
    [Icon_contracts_1.DashmixIconName.PiggyBankSolid]: 'fas fa-piggy-bank',
    [Icon_contracts_1.DashmixIconName.PillsSolid]: 'fas fa-pills',
    [Icon_contracts_1.DashmixIconName.PinterestBrand]: 'fab fa-pinterest',
    [Icon_contracts_1.DashmixIconName.PinterestPBrand]: 'fab fa-pinterest-p',
    [Icon_contracts_1.DashmixIconName.PinterestSquareBrand]: 'fab fa-pinterest-square',
    [Icon_contracts_1.DashmixIconName.PizzaSliceSolid]: 'fas fa-pizza-slice',
    [Icon_contracts_1.DashmixIconName.PlaceOfWorshipSolid]: 'fas fa-place-of-worship',
    [Icon_contracts_1.DashmixIconName.PlaneArrivalSolid]: 'fas fa-plane-arrival',
    [Icon_contracts_1.DashmixIconName.PlaneDepartureSolid]: 'fas fa-plane-departure',
    [Icon_contracts_1.DashmixIconName.PlaneSolid]: 'fas fa-plane',
    [Icon_contracts_1.DashmixIconName.PlayCircleSolid]: 'fas fa-play-circle',
    [Icon_contracts_1.DashmixIconName.PlayCircle]: 'far fa-play-circle',
    [Icon_contracts_1.DashmixIconName.PlaySolid]: 'fas fa-play',
    [Icon_contracts_1.DashmixIconName.PlaystationBrand]: 'fab fa-playstation',
    [Icon_contracts_1.DashmixIconName.PlugSolid]: 'fas fa-plug',
    [Icon_contracts_1.DashmixIconName.PlusCircleSolid]: 'fas fa-plus-circle',
    [Icon_contracts_1.DashmixIconName.PlusSolid]: 'fas fa-plus',
    [Icon_contracts_1.DashmixIconName.PlusSquareSolid]: 'fas fa-plus-square',
    [Icon_contracts_1.DashmixIconName.PlusSquare]: 'far fa-plus-square',
    [Icon_contracts_1.DashmixIconName.PodcastSolid]: 'fas fa-podcast',
    [Icon_contracts_1.DashmixIconName.PollHSolid]: 'fas fa-poll-h',
    [Icon_contracts_1.DashmixIconName.PollSolid]: 'fas fa-poll',
    [Icon_contracts_1.DashmixIconName.PooSolid]: 'fas fa-poo',
    [Icon_contracts_1.DashmixIconName.PooStormSolid]: 'fas fa-poo-storm',
    [Icon_contracts_1.DashmixIconName.PoopSolid]: 'fas fa-poop',
    [Icon_contracts_1.DashmixIconName.PortraitSolid]: 'fas fa-portrait',
    [Icon_contracts_1.DashmixIconName.PoundSignSolid]: 'fas fa-pound-sign',
    [Icon_contracts_1.DashmixIconName.PowerOffSolid]: 'fas fa-power-off',
    [Icon_contracts_1.DashmixIconName.PraySolid]: 'fas fa-pray',
    [Icon_contracts_1.DashmixIconName.PrayingHandsSolid]: 'fas fa-praying-hands',
    [Icon_contracts_1.DashmixIconName.PrescriptionBottleAltSolid]: 'fas fa-prescription-bottle-alt',
    [Icon_contracts_1.DashmixIconName.PrescriptionBottleSolid]: 'fas fa-prescription-bottle',
    [Icon_contracts_1.DashmixIconName.PrescriptionSolid]: 'fas fa-prescription',
    [Icon_contracts_1.DashmixIconName.PrintSolid]: 'fas fa-print',
    [Icon_contracts_1.DashmixIconName.ProceduresSolid]: 'fas fa-procedures',
    [Icon_contracts_1.DashmixIconName.ProductHuntBrand]: 'fab fa-product-hunt',
    [Icon_contracts_1.DashmixIconName.ProjectDiagramSolid]: 'fas fa-project-diagram',
    [Icon_contracts_1.DashmixIconName.PushedBrand]: 'fab fa-pushed',
    [Icon_contracts_1.DashmixIconName.PuzzlePieceSolid]: 'fas fa-puzzle-piece',
    [Icon_contracts_1.DashmixIconName.PythonBrand]: 'fab fa-python',
    [Icon_contracts_1.DashmixIconName.QqBrand]: 'fab fa-qq',
    [Icon_contracts_1.DashmixIconName.QrcodeSolid]: 'fas fa-qrcode',
    [Icon_contracts_1.DashmixIconName.QuestionCircleSolid]: 'fas fa-question-circle',
    [Icon_contracts_1.DashmixIconName.QuestionCircle]: 'far fa-question-circle',
    [Icon_contracts_1.DashmixIconName.QuestionSolid]: 'fas fa-question',
    [Icon_contracts_1.DashmixIconName.QuidditchSolid]: 'fas fa-quidditch',
    [Icon_contracts_1.DashmixIconName.QuinscapeBrand]: 'fab fa-quinscape',
    [Icon_contracts_1.DashmixIconName.QuoraBrand]: 'fab fa-quora',
    [Icon_contracts_1.DashmixIconName.QuoteLeftSolid]: 'fas fa-quote-left',
    [Icon_contracts_1.DashmixIconName.QuoteRightSolid]: 'fas fa-quote-right',
    [Icon_contracts_1.DashmixIconName.QuranSolid]: 'fas fa-quran',
    [Icon_contracts_1.DashmixIconName.RProjectBrand]: 'fab fa-r-project',
    [Icon_contracts_1.DashmixIconName.RadiationAltSolid]: 'fas fa-radiation-alt',
    [Icon_contracts_1.DashmixIconName.RadiationSolid]: 'fas fa-radiation',
    [Icon_contracts_1.DashmixIconName.RainbowSolid]: 'fas fa-rainbow',
    [Icon_contracts_1.DashmixIconName.RandomSolid]: 'fas fa-random',
    [Icon_contracts_1.DashmixIconName.RaspberryPiBrand]: 'fab fa-raspberry-pi',
    [Icon_contracts_1.DashmixIconName.RavelryBrand]: 'fab fa-ravelry',
    [Icon_contracts_1.DashmixIconName.ReactBrand]: 'fab fa-react',
    [Icon_contracts_1.DashmixIconName.ReacteuropeBrand]: 'fab fa-reacteurope',
    [Icon_contracts_1.DashmixIconName.ReadmeBrand]: 'fab fa-readme',
    [Icon_contracts_1.DashmixIconName.RebelBrand]: 'fab fa-rebel',
    [Icon_contracts_1.DashmixIconName.ReceiptSolid]: 'fas fa-receipt',
    [Icon_contracts_1.DashmixIconName.RecordVinylSolid]: 'fas fa-record-vinyl',
    [Icon_contracts_1.DashmixIconName.RecycleSolid]: 'fas fa-recycle',
    [Icon_contracts_1.DashmixIconName.RedRiverBrand]: 'fab fa-red-river',
    [Icon_contracts_1.DashmixIconName.RedditAlienBrand]: 'fab fa-reddit-alien',
    [Icon_contracts_1.DashmixIconName.RedditBrand]: 'fab fa-reddit',
    [Icon_contracts_1.DashmixIconName.RedditSquareBrand]: 'fab fa-reddit-square',
    [Icon_contracts_1.DashmixIconName.RedhatBrand]: 'fab fa-redhat',
    [Icon_contracts_1.DashmixIconName.RedoAltSolid]: 'fas fa-redo-alt',
    [Icon_contracts_1.DashmixIconName.RedoSolid]: 'fas fa-redo',
    [Icon_contracts_1.DashmixIconName.RegisteredSolid]: 'fas fa-registered',
    [Icon_contracts_1.DashmixIconName.Registered]: 'far fa-registered',
    [Icon_contracts_1.DashmixIconName.RemoveFormatSolid]: 'fas fa-remove-format',
    [Icon_contracts_1.DashmixIconName.RenrenBrand]: 'fab fa-renren',
    [Icon_contracts_1.DashmixIconName.ReplyAllSolid]: 'fas fa-reply-all',
    [Icon_contracts_1.DashmixIconName.ReplySolid]: 'fas fa-reply',
    [Icon_contracts_1.DashmixIconName.ReplydBrand]: 'fab fa-replyd',
    [Icon_contracts_1.DashmixIconName.RepublicanSolid]: 'fas fa-republican',
    [Icon_contracts_1.DashmixIconName.ResearchgateBrand]: 'fab fa-researchgate',
    [Icon_contracts_1.DashmixIconName.ResolvingBrand]: 'fab fa-resolving',
    [Icon_contracts_1.DashmixIconName.RestroomSolid]: 'fas fa-restroom',
    [Icon_contracts_1.DashmixIconName.RetweetSolid]: 'fas fa-retweet',
    [Icon_contracts_1.DashmixIconName.RevBrand]: 'fab fa-rev',
    [Icon_contracts_1.DashmixIconName.RibbonSolid]: 'fas fa-ribbon',
    [Icon_contracts_1.DashmixIconName.RingSolid]: 'fas fa-ring',
    [Icon_contracts_1.DashmixIconName.RoadSolid]: 'fas fa-road',
    [Icon_contracts_1.DashmixIconName.RobotSolid]: 'fas fa-robot',
    [Icon_contracts_1.DashmixIconName.RocketSolid]: 'fas fa-rocket',
    [Icon_contracts_1.DashmixIconName.RocketchatBrand]: 'fab fa-rocketchat',
    [Icon_contracts_1.DashmixIconName.RockrmsBrand]: 'fab fa-rockrms',
    [Icon_contracts_1.DashmixIconName.RouteSolid]: 'fas fa-route',
    [Icon_contracts_1.DashmixIconName.RssSolid]: 'fas fa-rss',
    [Icon_contracts_1.DashmixIconName.RssSquareSolid]: 'fas fa-rss-square',
    [Icon_contracts_1.DashmixIconName.RubleSignSolid]: 'fas fa-ruble-sign',
    [Icon_contracts_1.DashmixIconName.RulerCombinedSolid]: 'fas fa-ruler-combined',
    [Icon_contracts_1.DashmixIconName.RulerHorizontalSolid]: 'fas fa-ruler-horizontal',
    [Icon_contracts_1.DashmixIconName.RulerSolid]: 'fas fa-ruler',
    [Icon_contracts_1.DashmixIconName.RulerVerticalSolid]: 'fas fa-ruler-vertical',
    [Icon_contracts_1.DashmixIconName.RunningSolid]: 'fas fa-running',
    [Icon_contracts_1.DashmixIconName.RupeeSignSolid]: 'fas fa-rupee-sign',
    [Icon_contracts_1.DashmixIconName.SadCrySolid]: 'fas fa-sad-cry',
    [Icon_contracts_1.DashmixIconName.SadCry]: 'far fa-sad-cry',
    [Icon_contracts_1.DashmixIconName.SadTearSolid]: 'fas fa-sad-tear',
    [Icon_contracts_1.DashmixIconName.SadTear]: 'far fa-sad-tear',
    [Icon_contracts_1.DashmixIconName.SafariBrand]: 'fab fa-safari',
    [Icon_contracts_1.DashmixIconName.SalesforceBrand]: 'fab fa-salesforce',
    [Icon_contracts_1.DashmixIconName.SassBrand]: 'fab fa-sass',
    [Icon_contracts_1.DashmixIconName.SatelliteDishSolid]: 'fas fa-satellite-dish',
    [Icon_contracts_1.DashmixIconName.SatelliteSolid]: 'fas fa-satellite',
    [Icon_contracts_1.DashmixIconName.SaveSolid]: 'fas fa-save',
    [Icon_contracts_1.DashmixIconName.Save]: 'far fa-save',
    [Icon_contracts_1.DashmixIconName.SchlixBrand]: 'fab fa-schlix',
    [Icon_contracts_1.DashmixIconName.SchoolSolid]: 'fas fa-school',
    [Icon_contracts_1.DashmixIconName.ScrewdriverSolid]: 'fas fa-screwdriver',
    [Icon_contracts_1.DashmixIconName.ScribdBrand]: 'fab fa-scribd',
    [Icon_contracts_1.DashmixIconName.ScrollSolid]: 'fas fa-scroll',
    [Icon_contracts_1.DashmixIconName.SdCardSolid]: 'fas fa-sd-card',
    [Icon_contracts_1.DashmixIconName.SearchDollarSolid]: 'fas fa-search-dollar',
    [Icon_contracts_1.DashmixIconName.SearchLocationSolid]: 'fas fa-search-location',
    [Icon_contracts_1.DashmixIconName.SearchMinusSolid]: 'fas fa-search-minus',
    [Icon_contracts_1.DashmixIconName.SearchPlusSolid]: 'fas fa-search-plus',
    [Icon_contracts_1.DashmixIconName.SearchSolid]: 'fas fa-search',
    [Icon_contracts_1.DashmixIconName.SearchenginBrand]: 'fab fa-searchengin',
    [Icon_contracts_1.DashmixIconName.SeedlingSolid]: 'fas fa-seedling',
    [Icon_contracts_1.DashmixIconName.SellcastBrand]: 'fab fa-sellcast',
    [Icon_contracts_1.DashmixIconName.SellsyBrand]: 'fab fa-sellsy',
    [Icon_contracts_1.DashmixIconName.ServerSolid]: 'fas fa-server',
    [Icon_contracts_1.DashmixIconName.ServicestackBrand]: 'fab fa-servicestack',
    [Icon_contracts_1.DashmixIconName.ShapesSolid]: 'fas fa-shapes',
    [Icon_contracts_1.DashmixIconName.ShareAltSolid]: 'fas fa-share-alt',
    [Icon_contracts_1.DashmixIconName.ShareAltSquareSolid]: 'fas fa-share-alt-square',
    [Icon_contracts_1.DashmixIconName.ShareSolid]: 'fas fa-share',
    [Icon_contracts_1.DashmixIconName.ShareSquareSolid]: 'fas fa-share-square',
    [Icon_contracts_1.DashmixIconName.ShareSquare]: 'far fa-share-square',
    [Icon_contracts_1.DashmixIconName.ShekelSignSolid]: 'fas fa-shekel-sign',
    [Icon_contracts_1.DashmixIconName.ShieldAltSolid]: 'fas fa-shield-alt',
    [Icon_contracts_1.DashmixIconName.ShipSolid]: 'fas fa-ship',
    [Icon_contracts_1.DashmixIconName.ShippingFastSolid]: 'fas fa-shipping-fast',
    [Icon_contracts_1.DashmixIconName.ShirtsinbulkBrand]: 'fab fa-shirtsinbulk',
    [Icon_contracts_1.DashmixIconName.ShoePrintsSolid]: 'fas fa-shoe-prints',
    [Icon_contracts_1.DashmixIconName.ShopifyBrand]: 'fab fa-shopify',
    [Icon_contracts_1.DashmixIconName.ShoppingBagSolid]: 'fas fa-shopping-bag',
    [Icon_contracts_1.DashmixIconName.ShoppingBasketSolid]: 'fas fa-shopping-basket',
    [Icon_contracts_1.DashmixIconName.ShoppingCartSolid]: 'fas fa-shopping-cart',
    [Icon_contracts_1.DashmixIconName.ShopwareBrand]: 'fab fa-shopware',
    [Icon_contracts_1.DashmixIconName.ShowerSolid]: 'fas fa-shower',
    [Icon_contracts_1.DashmixIconName.ShuttleVanSolid]: 'fas fa-shuttle-van',
    [Icon_contracts_1.DashmixIconName.SignInAltSolid]: 'fas fa-sign-in-alt',
    [Icon_contracts_1.DashmixIconName.SignLanguageSolid]: 'fas fa-sign-language',
    [Icon_contracts_1.DashmixIconName.SignOutAltSolid]: 'fas fa-sign-out-alt',
    [Icon_contracts_1.DashmixIconName.SignSolid]: 'fas fa-sign',
    [Icon_contracts_1.DashmixIconName.SignalSolid]: 'fas fa-signal',
    [Icon_contracts_1.DashmixIconName.SignatureSolid]: 'fas fa-signature',
    [Icon_contracts_1.DashmixIconName.SimCardSolid]: 'fas fa-sim-card',
    [Icon_contracts_1.DashmixIconName.SimplybuiltBrand]: 'fab fa-simplybuilt',
    [Icon_contracts_1.DashmixIconName.SistrixBrand]: 'fab fa-sistrix',
    [Icon_contracts_1.DashmixIconName.SitemapSolid]: 'fas fa-sitemap',
    [Icon_contracts_1.DashmixIconName.SithBrand]: 'fab fa-sith',
    [Icon_contracts_1.DashmixIconName.SkatingSolid]: 'fas fa-skating',
    [Icon_contracts_1.DashmixIconName.SketchBrand]: 'fab fa-sketch',
    [Icon_contracts_1.DashmixIconName.SkiingNordicSolid]: 'fas fa-skiing-nordic',
    [Icon_contracts_1.DashmixIconName.SkiingSolid]: 'fas fa-skiing',
    [Icon_contracts_1.DashmixIconName.SkullCrossbonesSolid]: 'fas fa-skull-crossbones',
    [Icon_contracts_1.DashmixIconName.SkullSolid]: 'fas fa-skull',
    [Icon_contracts_1.DashmixIconName.SkyatlasBrand]: 'fab fa-skyatlas',
    [Icon_contracts_1.DashmixIconName.SkypeBrand]: 'fab fa-skype',
    [Icon_contracts_1.DashmixIconName.SlackBrand]: 'fab fa-slack',
    [Icon_contracts_1.DashmixIconName.SlackHashBrand]: 'fab fa-slack-hash',
    [Icon_contracts_1.DashmixIconName.SlashSolid]: 'fas fa-slash',
    [Icon_contracts_1.DashmixIconName.SleighSolid]: 'fas fa-sleigh',
    [Icon_contracts_1.DashmixIconName.SlidersHSolid]: 'fas fa-sliders-h',
    [Icon_contracts_1.DashmixIconName.SlideshareBrand]: 'fab fa-slideshare',
    [Icon_contracts_1.DashmixIconName.SmileBeamSolid]: 'fas fa-smile-beam',
    [Icon_contracts_1.DashmixIconName.SmileBeam]: 'far fa-smile-beam',
    [Icon_contracts_1.DashmixIconName.SmileSolid]: 'fas fa-smile',
    [Icon_contracts_1.DashmixIconName.SmileWinkSolid]: 'fas fa-smile-wink',
    [Icon_contracts_1.DashmixIconName.SmileWink]: 'far fa-smile-wink',
    [Icon_contracts_1.DashmixIconName.Smile]: 'far fa-smile',
    [Icon_contracts_1.DashmixIconName.SmogSolid]: 'fas fa-smog',
    [Icon_contracts_1.DashmixIconName.SmokingBanSolid]: 'fas fa-smoking-ban',
    [Icon_contracts_1.DashmixIconName.SmokingSolid]: 'fas fa-smoking',
    [Icon_contracts_1.DashmixIconName.SmsSolid]: 'fas fa-sms',
    [Icon_contracts_1.DashmixIconName.SnapchatBrand]: 'fab fa-snapchat',
    [Icon_contracts_1.DashmixIconName.SnapchatGhostBrand]: 'fab fa-snapchat-ghost',
    [Icon_contracts_1.DashmixIconName.SnapchatSquareBrand]: 'fab fa-snapchat-square',
    [Icon_contracts_1.DashmixIconName.SnowboardingSolid]: 'fas fa-snowboarding',
    [Icon_contracts_1.DashmixIconName.SnowflakeSolid]: 'fas fa-snowflake',
    [Icon_contracts_1.DashmixIconName.Snowflake]: 'far fa-snowflake',
    [Icon_contracts_1.DashmixIconName.SnowmanSolid]: 'fas fa-snowman',
    [Icon_contracts_1.DashmixIconName.SnowplowSolid]: 'fas fa-snowplow',
    [Icon_contracts_1.DashmixIconName.SocksSolid]: 'fas fa-socks',
    [Icon_contracts_1.DashmixIconName.SolarPanelSolid]: 'fas fa-solar-panel',
    [Icon_contracts_1.DashmixIconName.SortAlphaDownAltSolid]: 'fas fa-sort-alpha-down-alt',
    [Icon_contracts_1.DashmixIconName.SortAlphaDownSolid]: 'fas fa-sort-alpha-down',
    [Icon_contracts_1.DashmixIconName.SortAlphaUpAltSolid]: 'fas fa-sort-alpha-up-alt',
    [Icon_contracts_1.DashmixIconName.SortAlphaUpSolid]: 'fas fa-sort-alpha-up',
    [Icon_contracts_1.DashmixIconName.SortAmountDownAltSolid]: 'fas fa-sort-amount-down-alt',
    [Icon_contracts_1.DashmixIconName.SortAmountDownSolid]: 'fas fa-sort-amount-down',
    [Icon_contracts_1.DashmixIconName.SortAmountUpAltSolid]: 'fas fa-sort-amount-up-alt',
    [Icon_contracts_1.DashmixIconName.SortAmountUpSolid]: 'fas fa-sort-amount-up',
    [Icon_contracts_1.DashmixIconName.SortDownSolid]: 'fas fa-sort-down',
    [Icon_contracts_1.DashmixIconName.SortNumericDownAltSolid]: 'fas fa-sort-numeric-down-alt',
    [Icon_contracts_1.DashmixIconName.SortNumericDownSolid]: 'fas fa-sort-numeric-down',
    [Icon_contracts_1.DashmixIconName.SortNumericUpAltSolid]: 'fas fa-sort-numeric-up-alt',
    [Icon_contracts_1.DashmixIconName.SortNumericUpSolid]: 'fas fa-sort-numeric-up',
    [Icon_contracts_1.DashmixIconName.SortSolid]: 'fas fa-sort',
    [Icon_contracts_1.DashmixIconName.SortUpSolid]: 'fas fa-sort-up',
    [Icon_contracts_1.DashmixIconName.SoundcloudBrand]: 'fab fa-soundcloud',
    [Icon_contracts_1.DashmixIconName.SourcetreeBrand]: 'fab fa-sourcetree',
    [Icon_contracts_1.DashmixIconName.SpaSolid]: 'fas fa-spa',
    [Icon_contracts_1.DashmixIconName.SpaceShuttleSolid]: 'fas fa-space-shuttle',
    [Icon_contracts_1.DashmixIconName.SpeakapBrand]: 'fab fa-speakap',
    [Icon_contracts_1.DashmixIconName.SpeakerDeckBrand]: 'fab fa-speaker-deck',
    [Icon_contracts_1.DashmixIconName.SpellCheckSolid]: 'fas fa-spell-check',
    [Icon_contracts_1.DashmixIconName.SpiderSolid]: 'fas fa-spider',
    [Icon_contracts_1.DashmixIconName.SpinnerSolid]: 'fas fa-spinner fa-spin',
    [Icon_contracts_1.DashmixIconName.SplotchSolid]: 'fas fa-splotch',
    [Icon_contracts_1.DashmixIconName.SpotifyBrand]: 'fab fa-spotify',
    [Icon_contracts_1.DashmixIconName.SprayCanSolid]: 'fas fa-spray-can',
    [Icon_contracts_1.DashmixIconName.SquareFullSolid]: 'fas fa-square-full',
    [Icon_contracts_1.DashmixIconName.SquareRootAltSolid]: 'fas fa-square-root-alt',
    [Icon_contracts_1.DashmixIconName.SquareSolid]: 'fas fa-square',
    [Icon_contracts_1.DashmixIconName.Square]: 'far fa-square',
    [Icon_contracts_1.DashmixIconName.SquarespaceBrand]: 'fab fa-squarespace',
    [Icon_contracts_1.DashmixIconName.StackExchangeBrand]: 'fab fa-stack-exchange',
    [Icon_contracts_1.DashmixIconName.StackOverflowBrand]: 'fab fa-stack-overflow',
    [Icon_contracts_1.DashmixIconName.StackpathBrand]: 'fab fa-stackpath',
    [Icon_contracts_1.DashmixIconName.StampSolid]: 'fas fa-stamp',
    [Icon_contracts_1.DashmixIconName.StarAndCrescentSolid]: 'fas fa-star-and-crescent',
    [Icon_contracts_1.DashmixIconName.StarHalfAltSolid]: 'fas fa-star-half-alt',
    [Icon_contracts_1.DashmixIconName.StarHalfSolid]: 'fas fa-star-half',
    [Icon_contracts_1.DashmixIconName.StarHalf]: 'far fa-star-half',
    [Icon_contracts_1.DashmixIconName.StarOfDavidSolid]: 'fas fa-star-of-david',
    [Icon_contracts_1.DashmixIconName.StarOfLifeSolid]: 'fas fa-star-of-life',
    [Icon_contracts_1.DashmixIconName.StarSolid]: 'fas fa-star',
    [Icon_contracts_1.DashmixIconName.Star]: 'far fa-star',
    [Icon_contracts_1.DashmixIconName.StaylinkedBrand]: 'fab fa-staylinked',
    [Icon_contracts_1.DashmixIconName.SteamBrand]: 'fab fa-steam',
    [Icon_contracts_1.DashmixIconName.SteamSquareBrand]: 'fab fa-steam-square',
    [Icon_contracts_1.DashmixIconName.SteamSymbolBrand]: 'fab fa-steam-symbol',
    [Icon_contracts_1.DashmixIconName.StepBackwardSolid]: 'fas fa-step-backward',
    [Icon_contracts_1.DashmixIconName.StepForwardSolid]: 'fas fa-step-forward',
    [Icon_contracts_1.DashmixIconName.StethoscopeSolid]: 'fas fa-stethoscope',
    [Icon_contracts_1.DashmixIconName.StickerMuleBrand]: 'fab fa-sticker-mule',
    [Icon_contracts_1.DashmixIconName.StickyNoteSolid]: 'fas fa-sticky-note',
    [Icon_contracts_1.DashmixIconName.StickyNote]: 'far fa-sticky-note',
    [Icon_contracts_1.DashmixIconName.StopCircleSolid]: 'fas fa-stop-circle',
    [Icon_contracts_1.DashmixIconName.StopCircle]: 'far fa-stop-circle',
    [Icon_contracts_1.DashmixIconName.StopSolid]: 'fas fa-stop',
    [Icon_contracts_1.DashmixIconName.StopwatchSolid]: 'fas fa-stopwatch',
    [Icon_contracts_1.DashmixIconName.StoreAltSolid]: 'fas fa-store-alt',
    [Icon_contracts_1.DashmixIconName.StoreSolid]: 'fas fa-store',
    [Icon_contracts_1.DashmixIconName.StravaBrand]: 'fab fa-strava',
    [Icon_contracts_1.DashmixIconName.StreamSolid]: 'fas fa-stream',
    [Icon_contracts_1.DashmixIconName.StreetViewSolid]: 'fas fa-street-view',
    [Icon_contracts_1.DashmixIconName.StrikethroughSolid]: 'fas fa-strikethrough',
    [Icon_contracts_1.DashmixIconName.StripeBrand]: 'fab fa-stripe',
    [Icon_contracts_1.DashmixIconName.StripeSBrand]: 'fab fa-stripe-s',
    [Icon_contracts_1.DashmixIconName.StroopwafelSolid]: 'fas fa-stroopwafel',
    [Icon_contracts_1.DashmixIconName.StudiovinariBrand]: 'fab fa-studiovinari',
    [Icon_contracts_1.DashmixIconName.StumbleuponBrand]: 'fab fa-stumbleupon',
    [Icon_contracts_1.DashmixIconName.StumbleuponCircleBrand]: 'fab fa-stumbleupon-circle',
    [Icon_contracts_1.DashmixIconName.SubscriptSolid]: 'fas fa-subscript',
    [Icon_contracts_1.DashmixIconName.SubwaySolid]: 'fas fa-subway',
    [Icon_contracts_1.DashmixIconName.SuitcaseRollingSolid]: 'fas fa-suitcase-rolling',
    [Icon_contracts_1.DashmixIconName.SuitcaseSolid]: 'fas fa-suitcase',
    [Icon_contracts_1.DashmixIconName.SunSolid]: 'fas fa-sun',
    [Icon_contracts_1.DashmixIconName.Sun]: 'far fa-sun',
    [Icon_contracts_1.DashmixIconName.SuperpowersBrand]: 'fab fa-superpowers',
    [Icon_contracts_1.DashmixIconName.SuperscriptSolid]: 'fas fa-superscript',
    [Icon_contracts_1.DashmixIconName.SuppleBrand]: 'fab fa-supple',
    [Icon_contracts_1.DashmixIconName.SurpriseSolid]: 'fas fa-surprise',
    [Icon_contracts_1.DashmixIconName.Surprise]: 'far fa-surprise',
    [Icon_contracts_1.DashmixIconName.SuseBrand]: 'fab fa-suse',
    [Icon_contracts_1.DashmixIconName.SwatchbookSolid]: 'fas fa-swatchbook',
    [Icon_contracts_1.DashmixIconName.SwiftBrand]: 'fab fa-swift',
    [Icon_contracts_1.DashmixIconName.SwimmerSolid]: 'fas fa-swimmer',
    [Icon_contracts_1.DashmixIconName.SwimmingPoolSolid]: 'fas fa-swimming-pool',
    [Icon_contracts_1.DashmixIconName.SymfonyBrand]: 'fab fa-symfony',
    [Icon_contracts_1.DashmixIconName.SynagogueSolid]: 'fas fa-synagogue',
    [Icon_contracts_1.DashmixIconName.SyncAltSolid]: 'fas fa-sync-alt',
    [Icon_contracts_1.DashmixIconName.SyncSolid]: 'fas fa-sync',
    [Icon_contracts_1.DashmixIconName.SyringeSolid]: 'fas fa-syringe',
    [Icon_contracts_1.DashmixIconName.TableSolid]: 'fas fa-table',
    [Icon_contracts_1.DashmixIconName.TableTennisSolid]: 'fas fa-table-tennis',
    [Icon_contracts_1.DashmixIconName.TabletAltSolid]: 'fas fa-tablet-alt',
    [Icon_contracts_1.DashmixIconName.TabletSolid]: 'fas fa-tablet',
    [Icon_contracts_1.DashmixIconName.TabletsSolid]: 'fas fa-tablets',
    [Icon_contracts_1.DashmixIconName.TachometerAltSolid]: 'fas fa-tachometer-alt',
    [Icon_contracts_1.DashmixIconName.TagSolid]: 'fas fa-tag',
    [Icon_contracts_1.DashmixIconName.TagsSolid]: 'fas fa-tags',
    [Icon_contracts_1.DashmixIconName.TapeSolid]: 'fas fa-tape',
    [Icon_contracts_1.DashmixIconName.TasksSolid]: 'fas fa-tasks',
    [Icon_contracts_1.DashmixIconName.TaxiSolid]: 'fas fa-taxi',
    [Icon_contracts_1.DashmixIconName.TeamspeakBrand]: 'fab fa-teamspeak',
    [Icon_contracts_1.DashmixIconName.TeethOpenSolid]: 'fas fa-teeth-open',
    [Icon_contracts_1.DashmixIconName.TeethSolid]: 'fas fa-teeth',
    [Icon_contracts_1.DashmixIconName.TelegramBrand]: 'fab fa-telegram',
    [Icon_contracts_1.DashmixIconName.TelegramPlaneBrand]: 'fab fa-telegram-plane',
    [Icon_contracts_1.DashmixIconName.TemperatureHighSolid]: 'fas fa-temperature-high',
    [Icon_contracts_1.DashmixIconName.TemperatureLowSolid]: 'fas fa-temperature-low',
    [Icon_contracts_1.DashmixIconName.TencentWeiboBrand]: 'fab fa-tencent-weibo',
    [Icon_contracts_1.DashmixIconName.TengeSolid]: 'fas fa-tenge',
    [Icon_contracts_1.DashmixIconName.TerminalSolid]: 'fas fa-terminal',
    [Icon_contracts_1.DashmixIconName.TextHeightSolid]: 'fas fa-text-height',
    [Icon_contracts_1.DashmixIconName.TextWidthSolid]: 'fas fa-text-width',
    [Icon_contracts_1.DashmixIconName.ThLargeSolid]: 'fas fa-th-large',
    [Icon_contracts_1.DashmixIconName.ThListSolid]: 'fas fa-th-list',
    [Icon_contracts_1.DashmixIconName.ThSolid]: 'fas fa-th',
    [Icon_contracts_1.DashmixIconName.TheRedYetiBrand]: 'fab fa-the-red-yeti',
    [Icon_contracts_1.DashmixIconName.TheaterMasksSolid]: 'fas fa-theater-masks',
    [Icon_contracts_1.DashmixIconName.ThemecoBrand]: 'fab fa-themeco',
    [Icon_contracts_1.DashmixIconName.ThemeisleBrand]: 'fab fa-themeisle',
    [Icon_contracts_1.DashmixIconName.ThermometerEmptySolid]: 'fas fa-thermometer-empty',
    [Icon_contracts_1.DashmixIconName.ThermometerFullSolid]: 'fas fa-thermometer-full',
    [Icon_contracts_1.DashmixIconName.ThermometerHalfSolid]: 'fas fa-thermometer-half',
    [Icon_contracts_1.DashmixIconName.ThermometerQuarterSolid]: 'fas fa-thermometer-quarter',
    [Icon_contracts_1.DashmixIconName.ThermometerSolid]: 'fas fa-thermometer',
    [Icon_contracts_1.DashmixIconName.ThermometerThreeQuartersSolid]: 'fas fa-thermometer-three-quarters',
    [Icon_contracts_1.DashmixIconName.ThinkPeaksBrand]: 'fab fa-think-peaks',
    [Icon_contracts_1.DashmixIconName.ThumbsDownSolid]: 'fas fa-thumbs-down',
    [Icon_contracts_1.DashmixIconName.ThumbsDown]: 'far fa-thumbs-down',
    [Icon_contracts_1.DashmixIconName.ThumbsUpSolid]: 'fas fa-thumbs-up',
    [Icon_contracts_1.DashmixIconName.ThumbsUp]: 'far fa-thumbs-up',
    [Icon_contracts_1.DashmixIconName.ThumbtackSolid]: 'fas fa-thumbtack',
    [Icon_contracts_1.DashmixIconName.TicketAltSolid]: 'fas fa-ticket-alt',
    [Icon_contracts_1.DashmixIconName.TimesCircleSolid]: 'fas fa-times-circle',
    [Icon_contracts_1.DashmixIconName.TimesCircle]: 'far fa-times-circle',
    [Icon_contracts_1.DashmixIconName.TimesSolid]: 'fas fa-times',
    [Icon_contracts_1.DashmixIconName.TintSlashSolid]: 'fas fa-tint-slash',
    [Icon_contracts_1.DashmixIconName.TintSolid]: 'fas fa-tint',
    [Icon_contracts_1.DashmixIconName.TiredSolid]: 'fas fa-tired',
    [Icon_contracts_1.DashmixIconName.Tired]: 'far fa-tired',
    [Icon_contracts_1.DashmixIconName.ToggleOffSolid]: 'fas fa-toggle-off',
    [Icon_contracts_1.DashmixIconName.ToggleOnSolid]: 'fas fa-toggle-on',
    [Icon_contracts_1.DashmixIconName.ToiletPaperSolid]: 'fas fa-toilet-paper',
    [Icon_contracts_1.DashmixIconName.ToiletSolid]: 'fas fa-toilet',
    [Icon_contracts_1.DashmixIconName.ToolboxSolid]: 'fas fa-toolbox',
    [Icon_contracts_1.DashmixIconName.ToolsSolid]: 'fas fa-tools',
    [Icon_contracts_1.DashmixIconName.ToothSolid]: 'fas fa-tooth',
    [Icon_contracts_1.DashmixIconName.TorahSolid]: 'fas fa-torah',
    [Icon_contracts_1.DashmixIconName.ToriiGateSolid]: 'fas fa-torii-gate',
    [Icon_contracts_1.DashmixIconName.TractorSolid]: 'fas fa-tractor',
    [Icon_contracts_1.DashmixIconName.TradeFederationBrand]: 'fab fa-trade-federation',
    [Icon_contracts_1.DashmixIconName.TrademarkSolid]: 'fas fa-trademark',
    [Icon_contracts_1.DashmixIconName.TrafficLightSolid]: 'fas fa-traffic-light',
    [Icon_contracts_1.DashmixIconName.TrailerSolid]: 'fas fa-trailer',
    [Icon_contracts_1.DashmixIconName.TrainSolid]: 'fas fa-train',
    [Icon_contracts_1.DashmixIconName.TramSolid]: 'fas fa-tram',
    [Icon_contracts_1.DashmixIconName.TransgenderAltSolid]: 'fas fa-transgender-alt',
    [Icon_contracts_1.DashmixIconName.TransgenderSolid]: 'fas fa-transgender',
    [Icon_contracts_1.DashmixIconName.TrashAltSolid]: 'fas fa-trash-alt',
    [Icon_contracts_1.DashmixIconName.TrashAlt]: 'far fa-trash-alt',
    [Icon_contracts_1.DashmixIconName.TrashRestoreAltSolid]: 'fas fa-trash-restore-alt',
    [Icon_contracts_1.DashmixIconName.TrashRestoreSolid]: 'fas fa-trash-restore',
    [Icon_contracts_1.DashmixIconName.TrashSolid]: 'fas fa-trash',
    [Icon_contracts_1.DashmixIconName.TreeSolid]: 'fas fa-tree',
    [Icon_contracts_1.DashmixIconName.TrelloBrand]: 'fab fa-trello',
    [Icon_contracts_1.DashmixIconName.TripadvisorBrand]: 'fab fa-tripadvisor',
    [Icon_contracts_1.DashmixIconName.TrophySolid]: 'fas fa-trophy',
    [Icon_contracts_1.DashmixIconName.TruckLoadingSolid]: 'fas fa-truck-loading',
    [Icon_contracts_1.DashmixIconName.TruckMonsterSolid]: 'fas fa-truck-monster',
    [Icon_contracts_1.DashmixIconName.TruckMovingSolid]: 'fas fa-truck-moving',
    [Icon_contracts_1.DashmixIconName.TruckPickupSolid]: 'fas fa-truck-pickup',
    [Icon_contracts_1.DashmixIconName.TruckSolid]: 'fas fa-truck',
    [Icon_contracts_1.DashmixIconName.TshirtSolid]: 'fas fa-tshirt',
    [Icon_contracts_1.DashmixIconName.TtySolid]: 'fas fa-tty',
    [Icon_contracts_1.DashmixIconName.TumblrBrand]: 'fab fa-tumblr',
    [Icon_contracts_1.DashmixIconName.TumblrSquareBrand]: 'fab fa-tumblr-square',
    [Icon_contracts_1.DashmixIconName.TvSolid]: 'fas fa-tv',
    [Icon_contracts_1.DashmixIconName.TwitchBrand]: 'fab fa-twitch',
    [Icon_contracts_1.DashmixIconName.TwitterBrand]: 'fab fa-twitter',
    [Icon_contracts_1.DashmixIconName.TwitterSquareBrand]: 'fab fa-twitter-square',
    [Icon_contracts_1.DashmixIconName.Typo3Brand]: 'fab fa-typo3',
    [Icon_contracts_1.DashmixIconName.UberBrand]: 'fab fa-uber',
    [Icon_contracts_1.DashmixIconName.UbuntuBrand]: 'fab fa-ubuntu',
    [Icon_contracts_1.DashmixIconName.UikitBrand]: 'fab fa-uikit',
    [Icon_contracts_1.DashmixIconName.UmbracoBrand]: 'fab fa-umbraco',
    [Icon_contracts_1.DashmixIconName.UmbrellaBeachSolid]: 'fas fa-umbrella-beach',
    [Icon_contracts_1.DashmixIconName.UmbrellaSolid]: 'fas fa-umbrella',
    [Icon_contracts_1.DashmixIconName.UnderlineSolid]: 'fas fa-underline',
    [Icon_contracts_1.DashmixIconName.UndoAltSolid]: 'fas fa-undo-alt',
    [Icon_contracts_1.DashmixIconName.UndoSolid]: 'fas fa-undo',
    [Icon_contracts_1.DashmixIconName.UniregistryBrand]: 'fab fa-uniregistry',
    [Icon_contracts_1.DashmixIconName.UnityBrand]: 'fab fa-unity',
    [Icon_contracts_1.DashmixIconName.UniversalAccessSolid]: 'fas fa-universal-access',
    [Icon_contracts_1.DashmixIconName.UniversitySolid]: 'fas fa-university',
    [Icon_contracts_1.DashmixIconName.UnlinkSolid]: 'fas fa-unlink',
    [Icon_contracts_1.DashmixIconName.UnlockAltSolid]: 'fas fa-unlock-alt',
    [Icon_contracts_1.DashmixIconName.UnlockSolid]: 'fas fa-unlock',
    [Icon_contracts_1.DashmixIconName.UntappdBrand]: 'fab fa-untappd',
    [Icon_contracts_1.DashmixIconName.UploadSolid]: 'fas fa-upload',
    [Icon_contracts_1.DashmixIconName.UpsBrand]: 'fab fa-ups',
    [Icon_contracts_1.DashmixIconName.UsbBrand]: 'fab fa-usb',
    [Icon_contracts_1.DashmixIconName.UserAltSlashSolid]: 'fas fa-user-alt-slash',
    [Icon_contracts_1.DashmixIconName.UserAltSolid]: 'fas fa-user-alt',
    [Icon_contracts_1.DashmixIconName.UserAstronautSolid]: 'fas fa-user-astronaut',
    [Icon_contracts_1.DashmixIconName.UserCheckSolid]: 'fas fa-user-check',
    [Icon_contracts_1.DashmixIconName.UserCircleSolid]: 'fas fa-user-circle',
    [Icon_contracts_1.DashmixIconName.UserCircle]: 'far fa-user-circle',
    [Icon_contracts_1.DashmixIconName.UserClockSolid]: 'fas fa-user-clock',
    [Icon_contracts_1.DashmixIconName.UserCogSolid]: 'fas fa-user-cog',
    [Icon_contracts_1.DashmixIconName.UserEditSolid]: 'fas fa-user-edit',
    [Icon_contracts_1.DashmixIconName.UserFriendsSolid]: 'fas fa-user-friends',
    [Icon_contracts_1.DashmixIconName.UserGraduateSolid]: 'fas fa-user-graduate',
    [Icon_contracts_1.DashmixIconName.UserInjuredSolid]: 'fas fa-user-injured',
    [Icon_contracts_1.DashmixIconName.UserLockSolid]: 'fas fa-user-lock',
    [Icon_contracts_1.DashmixIconName.UserMdSolid]: 'fas fa-user-md',
    [Icon_contracts_1.DashmixIconName.UserMinusSolid]: 'fas fa-user-minus',
    [Icon_contracts_1.DashmixIconName.UserNinjaSolid]: 'fas fa-user-ninja',
    [Icon_contracts_1.DashmixIconName.UserNurseSolid]: 'fas fa-user-nurse',
    [Icon_contracts_1.DashmixIconName.UserPlusSolid]: 'fas fa-user-plus',
    [Icon_contracts_1.DashmixIconName.UserSecretSolid]: 'fas fa-user-secret',
    [Icon_contracts_1.DashmixIconName.UserShieldSolid]: 'fas fa-user-shield',
    [Icon_contracts_1.DashmixIconName.UserSlashSolid]: 'fas fa-user-slash',
    [Icon_contracts_1.DashmixIconName.UserSolid]: 'fas fa-user',
    [Icon_contracts_1.DashmixIconName.UserTagSolid]: 'fas fa-user-tag',
    [Icon_contracts_1.DashmixIconName.UserTieSolid]: 'fas fa-user-tie',
    [Icon_contracts_1.DashmixIconName.UserTimesSolid]: 'fas fa-user-times',
    [Icon_contracts_1.DashmixIconName.User]: 'far fa-user',
    [Icon_contracts_1.DashmixIconName.UsersCogSolid]: 'fas fa-users-cog',
    [Icon_contracts_1.DashmixIconName.UsersSolid]: 'fas fa-users',
    [Icon_contracts_1.DashmixIconName.UspsBrand]: 'fab fa-usps',
    [Icon_contracts_1.DashmixIconName.UssunnahBrand]: 'fab fa-ussunnah',
    [Icon_contracts_1.DashmixIconName.UtensilSpoonSolid]: 'fas fa-utensil-spoon',
    [Icon_contracts_1.DashmixIconName.UtensilsSolid]: 'fas fa-utensils',
    [Icon_contracts_1.DashmixIconName.VaadinBrand]: 'fab fa-vaadin',
    [Icon_contracts_1.DashmixIconName.VectorSquareSolid]: 'fas fa-vector-square',
    [Icon_contracts_1.DashmixIconName.VenusDoubleSolid]: 'fas fa-venus-double',
    [Icon_contracts_1.DashmixIconName.VenusMarsSolid]: 'fas fa-venus-mars',
    [Icon_contracts_1.DashmixIconName.VenusSolid]: 'fas fa-venus',
    [Icon_contracts_1.DashmixIconName.ViacoinBrand]: 'fab fa-viacoin',
    [Icon_contracts_1.DashmixIconName.ViadeoBrand]: 'fab fa-viadeo',
    [Icon_contracts_1.DashmixIconName.ViadeoSquareBrand]: 'fab fa-viadeo-square',
    [Icon_contracts_1.DashmixIconName.VialSolid]: 'fas fa-vial',
    [Icon_contracts_1.DashmixIconName.VialsSolid]: 'fas fa-vials',
    [Icon_contracts_1.DashmixIconName.ViberBrand]: 'fab fa-viber',
    [Icon_contracts_1.DashmixIconName.VideoSlashSolid]: 'fas fa-video-slash',
    [Icon_contracts_1.DashmixIconName.VideoSolid]: 'fas fa-video',
    [Icon_contracts_1.DashmixIconName.ViharaSolid]: 'fas fa-vihara',
    [Icon_contracts_1.DashmixIconName.VimeoBrand]: 'fab fa-vimeo',
    [Icon_contracts_1.DashmixIconName.VimeoSquareBrand]: 'fab fa-vimeo-square',
    [Icon_contracts_1.DashmixIconName.VimeoVBrand]: 'fab fa-vimeo-v',
    [Icon_contracts_1.DashmixIconName.VineBrand]: 'fab fa-vine',
    [Icon_contracts_1.DashmixIconName.VkBrand]: 'fab fa-vk',
    [Icon_contracts_1.DashmixIconName.VnvBrand]: 'fab fa-vnv',
    [Icon_contracts_1.DashmixIconName.VoicemailSolid]: 'fas fa-voicemail',
    [Icon_contracts_1.DashmixIconName.VolleyballBallSolid]: 'fas fa-volleyball-ball',
    [Icon_contracts_1.DashmixIconName.VolumeDownSolid]: 'fas fa-volume-down',
    [Icon_contracts_1.DashmixIconName.VolumeMuteSolid]: 'fas fa-volume-mute',
    [Icon_contracts_1.DashmixIconName.VolumeOffSolid]: 'fas fa-volume-off',
    [Icon_contracts_1.DashmixIconName.VolumeUpSolid]: 'fas fa-volume-up',
    [Icon_contracts_1.DashmixIconName.VoteYeaSolid]: 'fas fa-vote-yea',
    [Icon_contracts_1.DashmixIconName.VrCardboardSolid]: 'fas fa-vr-cardboard',
    [Icon_contracts_1.DashmixIconName.VuejsBrand]: 'fab fa-vuejs',
    [Icon_contracts_1.DashmixIconName.WalkingSolid]: 'fas fa-walking',
    [Icon_contracts_1.DashmixIconName.WalletSolid]: 'fas fa-wallet',
    [Icon_contracts_1.DashmixIconName.WarehouseSolid]: 'fas fa-warehouse',
    [Icon_contracts_1.DashmixIconName.WaterSolid]: 'fas fa-water',
    [Icon_contracts_1.DashmixIconName.WaveSquareSolid]: 'fas fa-wave-square',
    [Icon_contracts_1.DashmixIconName.WazeBrand]: 'fab fa-waze',
    [Icon_contracts_1.DashmixIconName.WeeblyBrand]: 'fab fa-weebly',
    [Icon_contracts_1.DashmixIconName.WeiboBrand]: 'fab fa-weibo',
    [Icon_contracts_1.DashmixIconName.WeightHangingSolid]: 'fas fa-weight-hanging',
    [Icon_contracts_1.DashmixIconName.WeightSolid]: 'fas fa-weight',
    [Icon_contracts_1.DashmixIconName.WeixinBrand]: 'fab fa-weixin',
    [Icon_contracts_1.DashmixIconName.WhatsappBrand]: 'fab fa-whatsapp',
    [Icon_contracts_1.DashmixIconName.WhatsappSquareBrand]: 'fab fa-whatsapp-square',
    [Icon_contracts_1.DashmixIconName.WheelchairSolid]: 'fas fa-wheelchair',
    [Icon_contracts_1.DashmixIconName.WhmcsBrand]: 'fab fa-whmcs',
    [Icon_contracts_1.DashmixIconName.WifiSolid]: 'fas fa-wifi',
    [Icon_contracts_1.DashmixIconName.WikipediaWBrand]: 'fab fa-wikipedia-w',
    [Icon_contracts_1.DashmixIconName.WindSolid]: 'fas fa-wind',
    [Icon_contracts_1.DashmixIconName.WindowCloseSolid]: 'fas fa-window-close',
    [Icon_contracts_1.DashmixIconName.WindowClose]: 'far fa-window-close',
    [Icon_contracts_1.DashmixIconName.WindowMaximizeSolid]: 'fas fa-window-maximize',
    [Icon_contracts_1.DashmixIconName.WindowMaximize]: 'far fa-window-maximize',
    [Icon_contracts_1.DashmixIconName.WindowMinimizeSolid]: 'fas fa-window-minimize',
    [Icon_contracts_1.DashmixIconName.WindowMinimize]: 'far fa-window-minimize',
    [Icon_contracts_1.DashmixIconName.WindowRestoreSolid]: 'fas fa-window-restore',
    [Icon_contracts_1.DashmixIconName.WindowRestore]: 'far fa-window-restore',
    [Icon_contracts_1.DashmixIconName.WindowsBrand]: 'fab fa-windows',
    [Icon_contracts_1.DashmixIconName.WineBottleSolid]: 'fas fa-wine-bottle',
    [Icon_contracts_1.DashmixIconName.WineGlassAltSolid]: 'fas fa-wine-glass-alt',
    [Icon_contracts_1.DashmixIconName.WineGlassSolid]: 'fas fa-wine-glass',
    [Icon_contracts_1.DashmixIconName.WixBrand]: 'fab fa-wix',
    [Icon_contracts_1.DashmixIconName.WizardsOfTheCoastBrand]: 'fab fa-wizards-of-the-coast',
    [Icon_contracts_1.DashmixIconName.WolfPackBattalionBrand]: 'fab fa-wolf-pack-battalion',
    [Icon_contracts_1.DashmixIconName.WonSignSolid]: 'fas fa-won-sign',
    [Icon_contracts_1.DashmixIconName.WordpressBrand]: 'fab fa-wordpress',
    [Icon_contracts_1.DashmixIconName.WordpressSimpleBrand]: 'fab fa-wordpress-simple',
    [Icon_contracts_1.DashmixIconName.WpbeginnerBrand]: 'fab fa-wpbeginner',
    [Icon_contracts_1.DashmixIconName.WpexplorerBrand]: 'fab fa-wpexplorer',
    [Icon_contracts_1.DashmixIconName.WpformsBrand]: 'fab fa-wpforms',
    [Icon_contracts_1.DashmixIconName.WpressrBrand]: 'fab fa-wpressr',
    [Icon_contracts_1.DashmixIconName.WrenchSolid]: 'fas fa-wrench',
    [Icon_contracts_1.DashmixIconName.XRaySolid]: 'fas fa-x-ray',
    [Icon_contracts_1.DashmixIconName.XboxBrand]: 'fab fa-xbox',
    [Icon_contracts_1.DashmixIconName.XingBrand]: 'fab fa-xing',
    [Icon_contracts_1.DashmixIconName.XingSquareBrand]: 'fab fa-xing-square',
    [Icon_contracts_1.DashmixIconName.YCombinatorBrand]: 'fab fa-y-combinator',
    [Icon_contracts_1.DashmixIconName.YahooBrand]: 'fab fa-yahoo',
    [Icon_contracts_1.DashmixIconName.YammerBrand]: 'fab fa-yammer',
    [Icon_contracts_1.DashmixIconName.YandexBrand]: 'fab fa-yandex',
    [Icon_contracts_1.DashmixIconName.YandexInternationalBrand]: 'fab fa-yandex-international',
    [Icon_contracts_1.DashmixIconName.YarnBrand]: 'fab fa-yarn',
    [Icon_contracts_1.DashmixIconName.YelpBrand]: 'fab fa-yelp',
    [Icon_contracts_1.DashmixIconName.YenSignSolid]: 'fas fa-yen-sign',
    [Icon_contracts_1.DashmixIconName.YinYangSolid]: 'fas fa-yin-yang',
    [Icon_contracts_1.DashmixIconName.YoastBrand]: 'fab fa-yoast',
    [Icon_contracts_1.DashmixIconName.YoutubeBrand]: 'fab fa-youtube',
    [Icon_contracts_1.DashmixIconName.YoutubeSquareBrand]: 'fab fa-youtube-square',
    [Icon_contracts_1.DashmixIconName.ZhihuBrand]: 'fab fa-zhihu'
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.dashmixIconSizeRegistry = {
    [composables_1.SizeMap.Large]: 'fa-4x',
    [composables_1.SizeMap.Medium]: 'fa-2x',
    [composables_1.SizeMap.Small]: '',
    [composables_1.SizeMap.XLarge]: 'fa-7x',
    [composables_1.SizeMap.XSmall]: 'fa-sm'
};
